(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bosco"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dataEl = document.getElementById('bosco-variant-data');
  if(!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const variants = data.variants;

  // --- START SVG ICONS (FIX 7060) ---
  const zoomStandard = "0 220 1080 680"; 
  const zoomVertical = "200 100 680 880"; 
  const zoomDetail   = "300 250 480 600"; 
  const zoomBox      = "0 0 100 75";

  const svgIcons = {
    depth: {
      '2500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="399.67 412.22 595.16 360.45 882.67 414.55 671.51 478.35 399.67 412.22"/><path fill="#f6f6f6" d="m595.24,362.5l279.03,52.5-202.81,61.28-263.66-64.14,187.44-49.64m-.15-4.1l-203.54,53.9,280.02,68.12,219.52-66.33-296-55.7h0Z"/></g><polygon points="671.57 492.41 391.55 424.29 391.55 412.29 671.57 480.41 671.57 492.41"/><polygon points="891.09 426.1 671.57 492.42 671.57 480.42 891.09 414.1 891.09 426.1"/><rect x="664.07" y="480.41" width="15" height="230"/><rect x="391.55" y="412.29" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="559.76" y1="453.21" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="504.11" y1="439.68" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="448.49" y1="426.15" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="615.42" y1="466.75" x2="827.82" y2="404.16"/></svg>`,
      '3000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="370.67 420.66 595.16 360.45 882.66 414.54 642.56 486.81 370.67 420.66"/><path fill="#f6f6f6" d="m595.24,362.5l278.98,52.49-231.72,69.74-263.76-64.17,216.5-58.07m-.16-4.1l-232.49,62.36,280.02,68.12,248.47-74.78-296-55.7h0Z"/></g><polygon points="642.62 500.88 362.6 432.76 362.6 420.76 642.62 488.88 642.62 500.88"/><polygon points="891.09 426.1 642.62 500.88 642.62 488.88 891.09 414.1 891.09 426.1"/><rect x="635.12" y="488.88" width="15" height="230"/><rect x="362.6" y="420.76" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="530.59" y1="461.62" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="474.59" y1="448" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="418.59" y1="434.38" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="586.59" y1="475.25" x2="827.82" y2="404.16"/></svg>`,
      '3500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="339.57 429.87 595.17 360.45 882.65 414.54 611.51 496.02 339.57 429.87"/><path fill="#f6f6f6" d="m595.25,362.5l278.96,52.49-262.76,78.96-263.86-64.19,247.65-67.26m-.16-4.1l-263.54,71.57,280.02,68.12,279.52-84-296-55.7h0Z"/></g><polygon points="611.57 510.09 331.55 441.97 331.55 429.97 611.57 498.09 611.57 510.09"/><polygon points="891.09 426.1 611.57 510.09 611.57 498.09 891.09 414.1 891.09 426.1"/><rect x="604.07" y="498.09" width="15" height="230"/><rect x="331.55" y="429.97" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="499.04" y1="470.72" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="442.65" y1="457" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="386.23" y1="443.28" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="555.41" y1="484.43" x2="827.82" y2="404.16"/></svg>`,
      '4000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="309.52 439.15 595.17 360.45 882.66 414.55 581.51 505.32 309.52 439.15"/><path fill="#f6f6f6" d="m595.26,362.5l278.98,52.5-292.79,88.25-263.97-64.22,277.77-76.52m-.17-4.1l-293.54,80.87,280.02,68.12,309.52-93.29-296-55.7h0Z"/></g><polygon points="581.57 519.39 301.55 451.27 301.55 439.27 581.57 507.39 581.57 519.39"/><polygon points="891.09 426.1 581.57 519.39 581.57 507.39 891.09 414.1 891.09 426.1"/><rect x="574.07" y="507.39" width="15" height="230"/><rect x="301.55" y="439.27" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="467.83" y1="479.72" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="411.05" y1="465.9" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="354.22" y1="452.08" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="524.57" y1="493.52" x2="827.82" y2="404.16"/></svg>`,
      '6000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="279.49 448.04 595.17 360.45 882.66 414.54 551.51 514.22 279.49 448.04"/><path fill="#f6f6f6" d="m595.26,362.5l278.97,52.49-322.77,97.15-264.03-64.23,307.83-85.41m-.17-4.1l-323.54,89.77,280.02,68.12,339.52-102.2-296-55.7h0Z"/></g><polygon points="551.57 528.29 271.55 460.17 271.55 448.17 551.57 516.29 551.57 528.29"/><polygon points="891.09 426.1 551.57 528.29 551.57 516.29 891.09 414.1 891.09 426.1"/><rect x="544.07" y="516.29" width="15" height="230"/><rect x="271.55" y="448.17" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="437.35" y1="488.51" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="380.19" y1="474.6" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="322.97" y1="460.68" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="494.46" y1="502.4" x2="827.82" y2="404.16"/></svg>`
    },
    width: {
      '3060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="393.16 426.13 620.17 365.25 857.34 409.9 620.03 481.32 393.16 426.13"/><path fill="#f6f6f6" d="m620.24,367.29l228.67,43.06-228.94,68.9-218.74-53.22,219.01-58.74m-.16-4.1l-235,63.03,235,57.17,245.68-73.94-245.68-46.26h0Z"/></g><polygon points="620.09 495.4 385.09 438.23 385.09 426.23 620.09 483.4 620.09 495.4"/><polygon points="866.09 421.47 620.09 495.4 620.09 483.4 866.09 409.47 866.09 421.47"/><rect x="612.59" y="483.4" width="15" height="230"/><rect x="385.09" y="426.23" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="561.34" y1="469.1" x2="800.18" y2="399.22"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="502.59" y1="454.81" x2="738.83" y2="387.57"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="443.84" y1="440.42" x2="676.56" y2="375.8"/></svg>`,
      '4060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="370.67 420.66 595.17 360.45 882.66 414.54 642.56 486.81 370.67 420.66"/><path fill="#f6f6f6" d="m595.24,362.5l278.98,52.49-231.72,69.74-263.76-64.17,216.5-58.07m-.16-4.1l-232.49,62.36,280.02,68.12,248.47-74.78-296-55.7h0Z"/></g><polygon points="642.62 500.88 362.6 432.76 362.6 420.76 642.62 488.88 642.62 500.88"/><polygon points="891.09 426.1 642.62 500.88 642.62 488.88 891.09 414.1 891.09 426.1"/><rect x="635.12" y="488.88" width="15" height="230"/><rect x="362.6" y="420.76" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="530.59" y1="461.62" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="474.59" y1="448" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="418.59" y1="434.38" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="586.59" y1="475.25" x2="827.82" y2="404.16"/></svg>`,
      '5060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="348.11 415.17 570.17 355.61 907.66 419.17 664.89 492.24 348.11 415.17"/><path fill="#f6f6f6" d="m570.24,357.66l328.99,61.96-234.39,70.55-308.65-75.09,214.06-57.41m-.16-4.1l-230.05,61.7,324.91,79.04,251.14-75.59-346-65.16h0Z"/></g><polygon points="664.95 506.31 340.04 427.27 340.04 415.27 664.95 494.31 664.95 506.31"/><polygon points="916.09 430.73 664.95 506.31 664.95 494.31 916.09 418.73 916.09 430.73"/><rect x="657.45" y="494.31" width="15" height="230"/><rect x="494.99" y="456.61" width="15" height="211.39"/><rect x="340.04" y="415.27" width="15" height="200.17"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="502.49" y1="454.79" x2="738.42" y2="387.38"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="448.41" y1="441.63" x2="681.03" y2="376.45"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="394.25" y1="428.45" x2="623.34" y2="365.6"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="556.73" y1="467.98" x2="796.65" y2="398.07"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="610.89" y1="481.16" x2="853.91" y2="409.04"/></svg>`,
      '6060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="325.97 409.78 545.17 350.99 932.66 423.93 687.47 497.73 325.97 409.78"/><path fill="#f6f6f6" d="m545.24,353.04l378.99,71.34-236.82,71.28-353.37-85.97,211.2-56.65m-.16-4.1l-227.19,60.94,369.63,89.92,253.56-76.32-396-74.54h0Z"/></g><polygon points="687.52 511.8 317.9 421.88 317.9 409.88 687.52 499.8 687.52 511.8"/><polygon points="941.09 435.49 687.52 511.8 687.52 499.8 941.09 423.49 941.09 435.49"/><rect x="680.02" y="499.8" width="15" height="230"/><rect x="495.21" y="453.31" width="15" height="212.9"/><rect x="317.9" y="409.88" width="15" height="197.73"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="476.22" y1="448.4" x2="710.05" y2="382.23"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="423.51" y1="435.57" x2="653.64" y2="371.52"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="370.8" y1="422.75" x2="596.81" y2="360.92"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="528.93" y1="460.84" x2="766.89" y2="392.82"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="581.64" y1="474.04" x2="823.58" y2="403.46"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="634.35" y1="486.87" x2="880.09" y2="414.14"/></svg>`,
    },
    polySpecs: {
      'Klar': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><line fill="none" stroke="#000" stroke-width="15" x1="704.17" y1="674.72" x2="607.52" y2="771.37"/><line fill="none" stroke="#000" stroke-width="15" x1="722.57" y1="730.67" x2="663.48" y2="789.76"/><line fill="none" stroke="#000" stroke-width="15" x1="372.05" y1="423.21" x2="468.71" y2="326.55"/><line fill="none" stroke="#000" stroke-width="15" x1="353.66" y1="367.25" x2="412.75" y2="308.16"/></svg>`,
      'Opal': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><g stroke="#000" stroke-width="5"><line x1="766.43" y1="210.83" x2="314.48" y2="869.39"/><line x1="766.57" y1="245.83" x2="340.7" y2="866.38"/><line x1="766.7" y1="280.83" x2="366.92" y2="863.37"/><line x1="766.83" y1="315.83" x2="393.13" y2="860.35"/><line x1="766.96" y1="350.83" x2="419.35" y2="857.34"/><line x1="767.09" y1="385.83" x2="445.57" y2="854.33"/><line x1="767.22" y1="420.83" x2="471.79" y2="851.32"/><line x1="767.35" y1="455.83" x2="498.01" y2="848.3"/><line x1="767.48" y1="490.84" x2="524.23" y2="845.29"/><line x1="767.61" y1="525.84" x2="550.45" y2="842.28"/><line x1="767.74" y1="560.84" x2="576.66" y2="839.27"/><line x1="767.87" y1="595.84" x2="602.88" y2="836.26"/><line x1="768.01" y1="630.84" x2="629.1" y2="833.24"/><line x1="768.14" y1="665.84" x2="655.32" y2="830.23"/><line x1="768.27" y1="700.84" x2="681.54" y2="827.22"/><line x1="768.4" y1="735.84" x2="707.76" y2="824.21"/><line x1="768.53" y1="770.85" x2="733.98" y2="821.19"/><line x1="314.48" y1="869.39" x2="766.43" y2="210.83"/><line x1="314.48" y1="834.39" x2="740.35" y2="213.84"/><line x1="314.48" y1="799.39" x2="714.26" y2="216.85"/><line x1="314.48" y1="764.39" x2="688.17" y2="219.86"/><line x1="314.48" y1="729.39" x2="662.08" y2="222.88"/><line x1="314.48" y1="694.39" x2="636" y2="225.89"/><line x1="314.48" y1="659.38" x2="609.91" y2="228.9"/><line x1="314.48" y1="624.38" x2="583.82" y2="231.91"/><line x1="314.48" y1="589.38" x2="557.73" y2="234.93"/><line x1="314.48" y1="554.38" x2="531.64" y2="237.94"/><line x1="314.48" y1="519.38" x2="505.56" y2="240.95"/><line x1="314.48" y1="484.38" x2="479.47" y2="243.96"/><line x1="314.48" y1="449.38" x2="453.38" y2="246.97"/><line x1="314.48" y1="414.37" x2="427.29" y2="249.99"/><line x1="314.48" y1="379.37" x2="401.21" y2="253"/><line x1="314.48" y1="344.37" x2="375.12" y2="256.01"/><line x1="314.48" y1="309.37" x2="349.03" y2="259.02"/></g></svg>`,
      'Solar Control': `<svg viewBox="0 0 1080 1080"><polyline fill="none" stroke="#000" stroke-width="15" points="607.53 206.24 790 182.57 790 832.57 290 897.43 290 247.43"/><g><circle fill="none" stroke="#000" stroke-width="15" cx="464.64" cy="267.56" r="61.04"/><line fill="none" stroke="#000" stroke-width="15" x1="464.64" y1="355.61" x2="464.64" y2="391.61"/><line fill="none" stroke="#000" stroke-width="15" x1="464.64" y1="143.51" x2="464.64" y2="179.51"/><line fill="none" stroke="#000" stroke-width="15" x1="376.59" y1="267.56" x2="340.59" y2="267.56"/><line fill="none" stroke="#000" stroke-width="15" x1="588.69" y1="267.56" x2="552.69" y2="267.56"/><line fill="none" stroke="#000" stroke-width="15" x1="402.38" y1="329.82" x2="376.92" y2="355.28"/><line fill="none" stroke="#000" stroke-width="15" x1="552.36" y1="179.84" x2="526.9" y2="205.3"/><line fill="none" stroke="#000" stroke-width="15" x1="402.38" y1="205.3" x2="376.92" y2="179.84"/><line fill="none" stroke="#000" stroke-width="15" x1="552.36" y1="355.28" x2="526.9" y2="329.82"/></g><g stroke="#000" stroke-width="5"><line x1="768.53" y1="210.83" x2="316.57" y2="869.39"/><line x1="768.53" y1="245.83" x2="342.66" y2="866.38"/><line x1="768.53" y1="280.83" x2="368.75" y2="863.37"/><line x1="768.53" y1="315.83" x2="394.84" y2="860.35"/><line x1="768.53" y1="350.83" x2="420.92" y2="857.34"/><line x1="768.53" y1="385.83" x2="447.01" y2="854.33"/><line x1="768.53" y1="420.83" x2="473.1" y2="851.32"/><line x1="768.53" y1="455.83" x2="499.19" y2="848.3"/><line x1="768.53" y1="490.84" x2="525.27" y2="845.29"/><line x1="768.53" y1="525.84" x2="551.36" y2="842.28"/><line x1="768.53" y1="560.84" x2="577.45" y2="839.27"/><line x1="768.53" y1="595.84" x2="603.54" y2="836.26"/><line x1="768.53" y1="630.84" x2="629.63" y2="833.24"/><line x1="768.53" y1="665.84" x2="655.71" y2="830.23"/><line x1="768.53" y1="700.84" x2="681.8" y2="827.22"/><line x1="768.53" y1="735.84" x2="707.89" y2="824.21"/><line x1="768.53" y1="770.85" x2="733.98" y2="821.19"/><line x1="316.57" y1="869.39" x2="768.53" y2="210.83"/><line x1="316.44" y1="834.39" x2="742.31" y2="213.84"/><line x1="316.31" y1="799.39" x2="716.09" y2="216.85"/><line x1="316.18" y1="764.39" x2="689.87" y2="219.86"/><line x1="316.05" y1="729.39" x2="663.65" y2="222.88"/><line x1="315.92" y1="694.39" x2="504.52" y2="418.61"/><line x1="315.79" y1="659.38" x2="478.3" y2="421.63"/><line x1="315.66" y1="624.38" x2="452.08" y2="424.64"/><line x1="315.53" y1="589.38" x2="425.87" y2="427.65"/><line x1="315.39" y1="554.38" x2="399.65" y2="430.66"/><line x1="315.26" y1="519.38" x2="394.43" y2="400.48"/><line x1="315.13" y1="484.38" x2="368.22" y2="403.49"/></g></svg>`,
      'Ultra-klar': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><line fill="none" stroke="#000" stroke-width="15" x1="704.17" y1="674.72" x2="607.52" y2="771.37"/><line fill="none" stroke="#000" stroke-width="15" x1="722.57" y1="730.67" x2="663.48" y2="789.76"/><line fill="none" stroke="#000" stroke-width="15" x1="372.05" y1="423.21" x2="468.71" y2="326.55"/><line fill="none" stroke="#000" stroke-width="15" x1="353.66" y1="367.25" x2="412.75" y2="308.16"/><path fill="none" stroke="#000" stroke-width="5" d="m712.1,369.7c-38.4,7.88-43.67,14.27-50.17,60.86-6.5-46.58-11.77-52.97-50.17-60.86,38.4-7.88,43.67-14.27,50.17-60.86,6.5,46.58,11.77,52.97,50.17,60.86Z"/><path fill="none" stroke="#000" stroke-width="5" d="m541.88,626.78c-38.4,7.88-43.67,14.27-50.17,60.86-6.5-46.58-11.77-52.97-50.17-60.86,38.4-7.88,43.67-14.27,50.17-60.86,6.5,46.58,11.77,52.97,50.17,60.86Z"/></svg>`
    },
    addons: {
      'rund': `<svg viewBox="${zoomStandard}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m340,260h285.82c5.15,4.26,114.18,98.11,114.18,280,0,8.37-2.28,187.49-114.18,280h-285.82"/></svg>`,
      'klassisch': `<svg viewBox="${zoomStandard}"><polyline fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" points="342.37 257.63 742.37 257.63 742.37 349.96 652.37 495.52 652.37 578.87 561.61 723.26 561.61 817.63 342.37 817.63"/></svg>`,
      'beton': `<svg viewBox="${zoomBox}"><rect x="15" y="25" width="70" height="40" fill="#e0e0e0" stroke="#888" stroke-width="3"/><path d="M15 25 L 30 10 L 100 10 L 85 25" fill="#f0f0f0" stroke="#888" stroke-width="3"/><path d="M85 25 L 85 65 L 100 50 L 100 10" fill="#ccc" stroke="#888" stroke-width="3"/></svg>`,
      'beton_abfluss': `<svg viewBox="${zoomBox}"><rect x="15" y="25" width="70" height="40" fill="#e0e0e0" stroke="#888" stroke-width="3"/><path d="M15 25 L 30 10 L 100 10 L 85 25" fill="#f0f0f0" stroke="#888" stroke-width="3"/><circle cx="50" cy="45" r="10" fill="#333" stroke="#888" stroke-width="2"/></svg>`,
      'bohrer': `<svg viewBox="${zoomBox}"><rect x="20" y="30" width="60" height="15" fill="#aaa" stroke="#666" stroke-width="2"/><path d="M80 30 L 95 37.5 L 80 45" fill="#666"/><rect x="5" y="25" width="15" height="25" fill="#444"/></svg>`,
      'heizung': `<svg viewBox="${zoomBox}"><rect x="10" y="20" width="80" height="20" rx="5" fill="#333"/><path d="M15 50 Q 25 40, 35 50 T 55 50 T 75 50 T 95 50" stroke="orange" stroke-width="3" fill="none"/><path d="M15 60 Q 25 50, 35 60 T 55 60 T 75 60 T 95 60" stroke="orange" stroke-width="3" fill="none"/></svg>`,
      'montage': `<svg viewBox="${zoomBox}"><rect x="20" y="20" width="60" height="40" fill="#d2b48c" stroke="#8b4513" stroke-width="2"/><path d="M20 20 L 50 40 L 80 20" stroke="#8b4513" stroke-width="2"/><path d="M50 20 L 50 60" stroke="#8b4513" stroke-width="2"/></svg>`,
      'stift': `<svg viewBox="${zoomBox}"><rect x="30" y="20" width="40" height="40" fill="#333" stroke="#000"/><path d="M30 60 L 50 75 L 70 60" fill="#555"/><rect x="30" y="5" width="40" height="15" fill="#888"/></svg>`,
      'profil': `<svg viewBox="${zoomBox}"><rect x="30" y="10" width="20" height="60" fill="#ccc" stroke="#666" stroke-width="2"/><rect x="50" y="50" width="30" height="20" fill="#ccc" stroke="#666" stroke-width="2"/></svg>`,
      'led': `<svg viewBox="${zoomDetail}"><rect fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x="350" y="718.89" width="357.83" height="101.11" rx=".9" ry=".9"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m529.17,376.5h10.69c59.87,0,108.47,48.6,108.47,108.47v234.59h-227.63v-234.59c0-59.87,48.6-108.47,108.47-108.47Z"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m540,425.03c-5.09-.01-31.13.44-52.39,21.49-20.74,20.53-22.1,45.97-22.27,51.29"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m532.41,583.47h4.22c23.63,0,42.82,19.19,42.82,42.82v92.6h-89.86v-92.6c0-23.63,19.19-42.82,42.82-42.82Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="540" y1="260" x2="540" y2="339.13"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="740" y1="331.9" x2="679.93" y2="382.77"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="340" y1="331.9" x2="400.07" y2="382.77"/></svg>`,
      'keilfenster': `<svg viewBox="${zoomVertical}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m830,473.86H250v-212.55c0-.8.55-1.41,1.16-1.29l578,118.86c.49.1.84.65.84,1.29v93.69Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="473.86" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="473.86" x2="250" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="336.94" y1="321.65" x2="281.89" y2="355.61"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="375.67" y1="335.45" x2="320.62" y2="369.4"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="723.12" y1="397.27" x2="668.07" y2="431.22"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="761.85" y1="411.06" x2="706.8" y2="445.02"/><path d="m830,473.86H250v-212.55c0-.8.55-1.41,1.16-1.29l578,118.86c.49.1.84.65.84,1.29v93.69Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="473.86" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="473.86" x2="250" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="336.94" y1="321.65" x2="281.89" y2="355.61"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="375.67" y1="335.45" x2="320.62" y2="369.4"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="723.12" y1="397.27" x2="668.07" y2="431.22"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="761.85" y1="411.06" x2="706.8" y2="445.02"/></svg>`,
      'seitenwand': `<svg viewBox="${zoomVertical}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m830,435.4H250v-174.33c0-.66.55-1.16,1.16-1.06l578,97.49c.49.08.84.53.84,1.06v76.84Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="435.4" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="435.4" x2="250" y2="820"/><path d="m670.43,447.81v347.19h-407.92v-347.19h407.92m25-25H237.51v397.19h457.92v-397.19h0Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="355.5" y1="487.97" x2="300.45" y2="521.92"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="394.23" y1="501.76" x2="339.18" y2="535.71"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="355.5" y1="487.97" x2="300.45" y2="521.92"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="588.32" y1="709.01" x2="533.27" y2="742.97"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="627.06" y1="722.81" x2="572" y2="756.76"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="588.32" y1="709.01" x2="533.27" y2="742.97"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="627.06" y1="722.81" x2="572" y2="756.76"/></svg>`,
      'schlagduebel': `<svg viewBox="400 200 280 680"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m462.5,260h220v6.9c0,26.92-21.85,48.77-48.77,48.77h-122.46c-26.92,0-48.77-21.85-48.77-48.77v-6.9h0Z"/><rect fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x="540" y="317.31" width="65" height="222.69"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="360.7" x2="605" y2="404.39"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="406.81" x2="605" y2="450.5"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="452.92" x2="605" y2="496.61"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m587.32,820h-29.73c-2.86,0-5.26-2.01-5.55-4.66l-28.68-265.77c-.46-4.25,3.14-7.94,7.74-7.94h82.8c4.6,0,8.2,3.69,7.74,7.94l-28.78,265.77c-.29,2.64-2.68,4.65-5.55,4.65Z"/></svg>`,
      'poly': `<svg viewBox="0 0 1080 1080"><path fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" d="m789.2,412.62h-498.4c-.47,0-.87.32-.98.78l-49.55,219.14c-.14.63.33,1.22.98,1.22h597.5c.64,0,1.12-.6.98-1.22l-49.55-219.14c-.1-.46-.51-.78-.98-.78Z"/><polyline fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" points="840 633.76 840 692.54 240 692.54 240 633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="540" y1="412.62" x2="540" y2="633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="621.53" y1="413.45" x2="648.47" y2="632.93"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="458.47" y1="413.45" x2="431.53" y2="632.93"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="705.8" y1="414.3" x2="744.2" y2="632.08"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="539.46" y1="633.21" x2="539.46" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="646.91" y1="633.21" x2="646.91" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="743.96" y1="633.21" x2="743.96" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="337" y1="633.21" x2="337" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="434.04" y1="633.21" x2="434.04" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="374.2" y1="414.3" x2="335.8" y2="632.08"/></svg>`,
      'glas': `<svg viewBox="0 0 1080 1080"><path fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" d="m789.2,412.62h-498.4c-.47,0-.87.32-.98.78l-49.55,219.14c-.14.63.33,1.22.98,1.22h597.5c.64,0,1.12-.6.98-1.22l-49.55-219.14c-.1-.46-.51-.78-.98-.78Z"/><polyline fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" points="840 633.76 840 692.54 240 692.54 240 633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="727.18" y1="540" x2="672.13" y2="573.96"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="765.92" y1="553.79" x2="710.87" y2="587.75"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="386.82" y1="451.78" x2="331.77" y2="485.73"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="425.56" y1="465.57" x2="370.51" y2="499.52"/></svg>`
    },
    colors: {
      'RAL9001': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#F2EAD6" stroke="#ddd" stroke-width="2"/></svg>`, 
      'RAL7016M': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#373F43"/></svg>`, 
      'RAL9016': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#FFFFFF" stroke="#E5E7EB" stroke-width="3"/></svg>`, 
      'RAL9005': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#1C1C1C"/></svg>` 
    }
  };
  const fallbackSVG = `<svg viewBox="0 0 100 75"><rect width="100" height="75" fill="#f5f5f5"/><text x="50" y="50" font-size="20" text-anchor="middle" dominant-baseline="middle" fill="#ccc">?</text></svg>`;
  // --- END SVG ICONS ---


  const varInput = document.getElementById('bosco-variant-id');
  const form = document.getElementById('bosco-product-form');
  
  const getAllButtons = () => {
    if(!form) return [];
    const btnsInside = Array.from(form.querySelectorAll('button[type="submit"]'));
    const btnsOutside = Array.from(document.querySelectorAll('button[type="submit"][form="bosco-product-form"]'));
    return [...btnsInside, ...btnsOutside];
  };

  const titW = document.getElementById('tit-width');
  const titD = document.getElementById('tit-depth');
  const titR = document.getElementById('tit-roof');
  const titC = document.getElementById('tit-color');
  const titA = document.getElementById('tit-addons');
  const colorInput = document.getElementById('prop-color');
  const noteRAL = document.getElementById('note-ral9001');
  const ralCard = document.getElementById('swatch-ral9001');
  const pcWrap = document.getElementById('poly-subtype-wrap');
  const warnGlass = document.getElementById('warn-glass-span');
  const warnBeam  = document.getElementById('warn-beam');
  const reinfChk  = document.getElementById('prop-reinf');
  const accItems = [...document.querySelectorAll('.g-acc__item')];
  
  const sumPriceLine = document.getElementById('sum-price-line');
  const sumAddonsPrice = document.getElementById('sum-addons-price');
  const sumPriceFinal = document.getElementById('sum-price-final');
  
  const sumDimensionsWrap = document.getElementById('sum-dimensions-wrap');
  const sumWidth = document.getElementById('sum-width');
  const sumDepth = document.getElementById('sum-depth');
  const sumColorWrap = document.getElementById('sum-color-wrap');
  const sumColor = document.getElementById('sum-color');
  const sumRoofWrap = document.getElementById('sum-roof-wrap');
  const sumRoof = document.getElementById('sum-roof');
  const sumPcSpec = document.getElementById('sum-pc-spec');
  const sumAddonsWrap = document.getElementById('sum-addons-wrap');
  const sumAddonsList = document.getElementById('sum-addons-list');
  const validationMessage = document.getElementById('bosco-validation-message');

  const footerSummaryText = document.getElementById('footer-summary-text');
  const footerPriceFinal = document.getElementById('footer-price-final');
  
  const addonPriceCache = {};
  
  const fetchProductPrice = async (handle) => {
    if (addonPriceCache[handle]) return addonPriceCache[handle];
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return 0;
      const product = await response.json();
      const price = product.variants[0].price;
      addonPriceCache[handle] = price;
      return price;
    } catch (e) { return 0; }
  };

  // NEW: Updates the visible price tag on all addon cards
  const updateUIAddonPrices = async () => {
    const targets = form.querySelectorAll('[data-handle]'); 
    for(const t of targets){
       const handle = t.dataset.handle;
       const price = await fetchProductPrice(handle);
       const card = t.closest('.g-card');
       const priceEl = card ? card.querySelector('.g-card__price') : null;
       if(priceEl) priceEl.textContent = fmt(price);
    }
  };
  
  function generateChoiceCards(containerId, inputName, options, type) {
    const container = document.getElementById(containerId);
    if (!container) return;
    
    container.innerHTML = options.map(opt => {
      // Anpassung: Entferne " mm", falls vorhanden, um den Key im svgIcons-Objekt zu finden
      const cleanOpt = opt.replace(' mm', '');
let iconSvg = fallbackSVG;

if (svgIcons[type] && svgIcons[type][cleanOpt]) {
  iconSvg = svgIcons[type][cleanOpt];
} else if (type === 'width' && svgIcons.width['6060']) {
  iconSvg = svgIcons.width['6060'];
} else if (type === 'depth' && svgIcons.depth[cleanOpt]) {
  iconSvg = svgIcons.depth[cleanOpt];
}      return `
        <label class="g-card">
          <input type="radio" name="${inputName}" value="${opt}" class="visually-hidden">
          <div class="g-card__thumb">${iconSvg}</div>
          <div class="g-card__label">${opt}</div>
        </label>
      `;
    }).join('');
  }
  const unique = arr => [...new Set(arr)];
  const widths = unique(variants.map(v => v.option1)).sort();
  const depths = unique(variants.map(v => v.option2)).sort((a,b)=>parseInt(a)-parseInt(b));

  generateChoiceCards('width-options-grid', 'opt-width', widths, 'width');
  generateChoiceCards('depth-options-grid', 'opt-depth', depths, 'depth');

  function updateStaticIcon(selector, iconKey, type) {
    if(selector) {
      const el = form.querySelector(selector);
      if(el) {
        const card = el.classList.contains('g-card') ? el : el.closest('.g-card');
        const thumb = card?.querySelector('.g-card__thumb');
        if(thumb && svgIcons[type] && svgIcons[type][iconKey]) {
          thumb.innerHTML = svgIcons[type][iconKey];
        }
      }
    }
  }
  
  const iconCards = form.querySelectorAll('.g-card__thumb[data-icon]');
  iconCards.forEach(thumb => {
      const iconKey = thumb.dataset.icon;
      if(svgIcons.addons[iconKey]) {
          thumb.innerHTML = svgIcons.addons[iconKey];
      }
  });


  updateStaticIcon('input[value="rund"]', 'rund', 'addons');
  updateStaticIcon('input[value="klassisch"]', 'klassisch', 'addons');
  updateStaticIcon('button[data-color="RAL9001"]', 'RAL9001', 'colors');
  updateStaticIcon('button[data-color="RAL7016M"]', 'RAL7016M', 'colors');
  updateStaticIcon('button[data-color="RAL9016"]', 'RAL9016', 'colors');
  updateStaticIcon('button[data-color="RAL9005"]', 'RAL9005', 'colors');

  updateStaticIcon('input[value="Klar"]', 'Klar', 'polySpecs');
  updateStaticIcon('input[value="Opal"]', 'Opal', 'polySpecs');
  updateStaticIcon('input[value="Solar Control"]', 'Solar Control', 'polySpecs');
  updateStaticIcon('input[value="Ultra-klar"]', 'Ultra-klar', 'polySpecs');

  updateStaticIcon('input[value="Polycarbonat"]', 'poly', 'addons');
  updateStaticIcon('input[value="Glas"]', 'glas', 'addons');
  
  // MAIN ACCORDION LOGIC
  accItems.forEach((item) => {
    const summary = item.querySelector('.g-acc__summary');
    const content = item.querySelector('.g-acc__body');
    
    // Initial State
    if (item.hasAttribute('open')) { 
       content.style.maxHeight = 'none'; // Allow dynamic height for pre-opened items
    } else { 
       content.style.maxHeight = '0px'; 
    }
    
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (item.hasAttribute('open')) {
        // Closing
        content.style.maxHeight = content.scrollHeight + 'px'; // Set pixel height first for transition
        setTimeout(() => { content.style.maxHeight = '0px'; }, 10);
        setTimeout(() => { item.removeAttribute('open'); }, 500); // Wait for transition
      } else {
        // Opening
        item.setAttribute('open', '');
        content.style.maxHeight = content.scrollHeight + 'px';
        // After transition, remove max-height constraint to allow inner accordions to expand
        setTimeout(() => { 
            if(item.hasAttribute('open')) content.style.maxHeight = 'none'; 
        }, 500);
      }
    });
  });

  // SUB ACCORDION LOGIC
  const subItems = document.querySelectorAll('.g-acc__sub');
  subItems.forEach((item) => {
    const summary = item.querySelector('.g-acc__sub-summary');
    const content = item.querySelector('.g-acc__sub-body');

    if (!item.hasAttribute('open')) { content.style.maxHeight = '0px'; }

    summary.addEventListener('click', (e) => {
        e.preventDefault();
        const parentBody = item.closest('.g-acc__body'); // The parent container

        if (item.hasAttribute('open')) {
            // Closing sub-item
            content.style.maxHeight = content.scrollHeight + 'px';
            setTimeout(() => { content.style.maxHeight = '0px'; }, 10);
            setTimeout(() => { item.removeAttribute('open'); }, 300);
        } else {
            // Opening sub-item
            item.setAttribute('open', '');
            content.style.maxHeight = content.scrollHeight + 'px';
            setTimeout(() => { 
                if(item.hasAttribute('open')) content.style.maxHeight = 'none'; 
            }, 300);
        }
    });
  });

  const closeCurrentStep = (el) => {
    const currentItem = el.closest('.g-acc__item');
    if (currentItem && currentItem.hasAttribute('open')) { 
        // We trigger click to close, so it animates
        currentItem.querySelector('.g-acc__summary').click(); 
    }
  };
  
  const flashElement = (el) => {
    el.classList.add('flash-animation');
    setTimeout(() => { el.classList.remove('flash-animation'); }, 700);
  };

  const getSelectedValue = name => form.querySelector(`input[name="${name}"]:checked`)?.value || '';
  const fmt = (c) => (typeof Shopify!=='undefined'&&Shopify.formatMoney)? Shopify.formatMoney(c):(c/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'});

  function setColor(val, labelText){
    const colorCards = form.querySelectorAll('#color-swatches .g-card');
    colorInput.value = val || '';
    colorCards.forEach(c => {
      const active = c.dataset.color === val;
      c.setAttribute('aria-pressed', String(active));
      c.setAttribute('aria-checked', String(active));
    });
    const newColorText = labelText || (val || '–');
    if (titC.textContent !== newColorText) {
      titC.textContent = newColorText;
      flashElement(titC);
    }
    validateAndRender();
  }
  
  async function validateAndRender(){
    const w = getSelectedValue('opt-width');
    const d = getSelectedValue('opt-depth');
    const r = getSelectedValue('opt-roof');
    let pcSubtype = getSelectedValue('properties[pc_subtype]');

if (r === 'Polycarbonat') {
  const subtypes = ['Klar', 'Opal', 'Ultra-klar', 'Solar Control'];

  subtypes.forEach(subtype => {
    const input = form.querySelector(`input[name="properties[pc_subtype]"][value="${subtype}"]`);
    if (!input) return;

    const card = input.closest('.g-card');
    if (!card) return;

    if (!w || !d) {
      card.classList.remove('option-disabled');
      return;
    }

    const variantLabel = `Polycarbonat ${subtype}`;

    const variantExists = variants.some(
      v => v.option1 == w && v.option2 == d && v.option3 == variantLabel
    );

    card.classList.toggle('option-disabled', !variantExists);

    if (!variantExists && input.checked) {
      input.checked = false;
      pcSubtype = '';
    }
  });


}



let variantOption3 = r;
if (r === 'Polycarbonat' && pcSubtype) {
  variantOption3 = `Polycarbonat ${pcSubtype}`;
}

    const variant = (w && d && variantOption3) ? 
        variants.find(v => v.option1 == w && v.option2 == d && v.option3 == variantOption3) 
        : null;
    
    const newWidthText = w ? `${w}` : '–';
    if (titW.textContent !== newWidthText) { titW.textContent = newWidthText; flashElement(titW); }
    const newDepthText = d ? `${d}` : '–';
    if (titD.textContent !== newDepthText) { titD.textContent = newDepthText; flashElement(titD); }
const newRoofText = r === 'Polycarbonat' && pcSubtype
  ? `Polycarbonat ${pcSubtype}`
  : (r || '–');

if (titR.textContent !== newRoofText) {
  titR.textContent = newRoofText;
  flashElement(titR);
}

    sumDimensionsWrap.classList.toggle('hidden', !w || !d);
    sumWidth.textContent = w;
    sumDepth.textContent = d;
    sumColorWrap.classList.toggle('hidden', !colorInput.value);
    sumColor.textContent = colorInput.value;
    sumRoofWrap.classList.toggle('hidden', !r);
sumRoof.textContent = r === 'Polycarbonat' && pcSubtype
  ? `Polycarbonat ${pcSubtype}`
  : r;
      sumPcSpec.classList.toggle('hidden', r !== 'Polycarbonat');

    const zier = getSelectedValue('addon-zierleiste');
    const qtyInputs = form.querySelectorAll('.addon-qty');
    let hasQtyAddons = false;
    let addonTextList = [];
    if(zier) addonTextList.push(zier);

    qtyInputs.forEach(input => {
        if(parseInt(input.value) > 0) {
            hasQtyAddons = true;
            const card = input.closest('.g-card');
            const label = card.querySelector('.g-card__label').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            addonTextList.push(`${input.value}x ${label}`);
        }
    });

    sumAddonsWrap.classList.toggle('hidden', addonTextList.length === 0);
    sumAddonsList.textContent = addonTextList.join(', ');

    if (w === '7060') {
      noteRAL.classList.remove('hidden'); ralCard?.classList.add('option-disabled'); ralCard?.setAttribute('aria-disabled','true'); ralCard?.setAttribute('tabindex','-1');
      if (colorInput.value === 'RAL9001') setColor('', '');
    } else {
      noteRAL.classList.add('hidden'); ralCard?.classList.remove('option-disabled'); ralCard?.removeAttribute('aria-disabled'); ralCard?.removeAttribute('tabindex');
    }
    
    // Poly wrapper logic removed since we always show it for Bosco
    // const isPoly = r === 'Polycarbonat';
    // pcWrap.classList.toggle('hidden', !isPoly);
    
    if (variant && r === 'Glas') {
      const span = variant.metafields.max_post_span_mm.value || 0;
      warnGlass.textContent = span ? `Hinweis: Bei Glas beträgt der maximale Pfostenabstand ${span} mm.` : '';
      warnGlass.classList.toggle('hidden', !span);
    } else { warnGlass.classList.add('hidden'); }

    const is6000 = d === '6000';
    const wasHiddenBeam = warnBeam.classList.contains('hidden');
    warnBeam.classList.toggle('hidden', !is6000);
    if (!is6000 && reinfChk) reinfChk.checked = false;
    
    let basePrice = 0;
    if (variant && variant.available) {
      varInput.value = variant.id;
      basePrice = variant.price;
    } else {
      varInput.value = '';
    }

    let addonTotal = 0;
    
    if(zier) {
        const r = form.querySelector('input[name="addon-zierleiste"]:checked');
        const price = await fetchProductPrice(r.dataset.handle);
        addonTotal += price; 
    }

    for (const input of qtyInputs) {
      const qty = parseInt(input.value);
      if (qty > 0) {
        const card = input.closest('.g-card');
        const price = await fetchProductPrice(card.dataset.handle);
        addonTotal += (price * qty);
      }
    }

    const finalPrice = basePrice + addonTotal;
    sumPriceLine.textContent = fmt(basePrice);
    sumAddonsPrice.textContent = fmt(addonTotal);
    sumPriceFinal.textContent = fmt(finalPrice);
    footerPriceFinal.textContent = fmt(finalPrice);
    
    const summaryItems = [w ? `${w}x${d}mm` : null, colorInput.value, r, zier, hasQtyAddons ? `Zubehör` : null].filter(Boolean);
    footerSummaryText.textContent = summaryItems.join(' / ');

    let totalAddonCount = 0;
    qtyInputs.forEach(i => totalAddonCount += parseInt(i.value));
    if (zier) { totalAddonCount += 1; }
    const newAddonText = totalAddonCount > 0 ? `${totalAddonCount} Artikel` : '–';
    if (titA.textContent !== newAddonText) {
      titA.textContent = newAddonText;
      flashElement(titA);
    }
    
    const missingSelections = [];
    if (!w) missingSelections.push('Breite');
    if (!d) missingSelections.push('Ausfall');
    if (!r) missingSelections.push('Dacheindeckung');
    if (!colorInput.value) missingSelections.push('Farbe');
    
    if (r === 'Polycarbonat' && !pcSubtype) missingSelections.push('Polycarbonat-Ausführung');
    if (d === '6000' && !reinfChk.checked) missingSelections.push('Bestätigung (6000mm)');

    const allButtons = getAllButtons();
    if (missingSelections.length > 0) {
      validationMessage.textContent = `Bitte wählen Sie noch: ${missingSelections.join(', ')}`;
      validationMessage.classList.remove('hidden');
      allButtons.forEach(btn => btn.disabled = true);
    } else {
      validationMessage.classList.add('hidden');
      const shouldDisable = !varInput.value;
      allButtons.forEach(btn => btn.disabled = shouldDisable);
    }
  }

  const resetConfigurator = () => {
    form.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
         if(input.name !== 'opt-roof') input.checked = false; 
    });
    form.querySelectorAll('.addon-qty').forEach(i => i.value = 0);
    form.querySelectorAll('.g-card').forEach(c => c.classList.remove('has-qty'));
    // Close Sub-Accordions
    subItems.forEach(item => {
        if(item.hasAttribute('open')) {
            item.removeAttribute('open');
            item.querySelector('.g-acc__sub-body').style.maxHeight = '0px';
        }
    });

    setColor('', '');
    validateAndRender();
    accItems.forEach(item => {
      if (!item.hasAttribute('open')) { item.querySelector('.g-acc__summary').click(); }
    });
    document.querySelector('.g-acc__item[data-step="1"]')?.scrollIntoView({ behavior: 'smooth' });
  };

  form.querySelector('#color-swatches').addEventListener('click', (e) => {
    const card = e.target.closest('.g-card');
    if (card) { setColor(card.dataset.color, card.dataset.label); closeCurrentStep(card); }
  });
  
form.addEventListener('change', (e) => {
  const target = e.target;

  if (target.matches('input[type="radio"]')) {
    const isPolyRadio = target.name === 'opt-roof' && target.value === 'Polycarbonat';
    const isPcSubtype = target.name === 'properties[pc_subtype]';
    const is6000mmRadio = target.name === 'opt-depth' && target.value === '6000';
    const inAddons = target.closest('#giallo-addons');

    if (!inAddons && !is6000mmRadio) {
      if (isPcSubtype) {
        closeCurrentStep(target);
      } else if (!isPolyRadio) {
        closeCurrentStep(target);
      }
    }
  }

  validateAndRender();
});

  form.addEventListener('click', (e) => {
    if (e.target.matches('.g-qty-btn')) {
        const btn = e.target;
        const wrapper = btn.closest('.g-qty-wrapper');
        const input = wrapper.querySelector('input');
        const card = btn.closest('.g-card');
        let val = parseInt(input.value) || 0;

        if (btn.classList.contains('plus')) {
            val++;
        } else if (btn.classList.contains('minus')) {
            if (val > 0) val--;
        }
        
        input.value = val;
        
        if (val > 0) {
            card.classList.add('has-qty');
        } else {
            card.classList.remove('has-qty');
        }
        
        validateAndRender();
    }
  });


  document.getElementById('addon-zierleiste-clear')?.addEventListener('click', () => {
    const r = form.querySelector('input[name="addon-zierleiste"]:checked');
    if (r) r.checked = false;
    validateAndRender();
  });

  document.getElementById('bosco-reset-btn')?.addEventListener('click', resetConfigurator);
  
  const handleAddClick = (e) => {
    const btn = e.currentTarget;
    if (btn && btn.disabled) {
      e.preventDefault();
      const validationMessage = document.getElementById('bosco-validation-message');
      if (validationMessage && !validationMessage.classList.contains('hidden')) {
        validationMessage.classList.add('shake-animation');
        setTimeout(() => { validationMessage.classList.remove('shake-animation'); }, 600);
      }
    }
  };
  
  getAllButtons().forEach(btn => {
    btn.addEventListener('click', handleAddClick);
  });

  // Call the new UI updater here
  updateUIAddonPrices();
  validateAndRender();

  async function getFirstVariantIdByHandle(handle){
    try{
      const res = await fetch(`/products/${handle}.js`); if(!res.ok) return null;
      const p = await res.json(); return p?.variants?.[0]?.id || null;
    }catch(e){ return null; }
  }

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const allButtons = getAllButtons();
    if (allButtons.some(btn => btn.disabled)) return;
    
    allButtons.forEach(btn => btn.disabled = true);
    
    try {
      const mainVariantId = varInput.value;
      if(!mainVariantId) return;
      const configurationId = Date.now();
      const formData = new FormData(form);
      const properties = {};
      for (const [k, v] of formData.entries()) {
        if (k.startsWith('properties[')) properties[k.slice(11,-1)] = v;
      }
      properties['_config_id'] = configurationId;
      
      const addItems = [{ id: Number(mainVariantId), quantity: 1, properties }];
      
      const zier = form.querySelector('input[name="addon-zierleiste"]:checked');
      if (zier) {
        const vid = await getFirstVariantIdByHandle(zier.dataset.handle);
        if (vid) addItems.push({ id: Number(vid), quantity: 1, properties: { _parent: String(mainVariantId), _lock_qty: '1', _config_id: configurationId } });
      }

      const qtyInputs = form.querySelectorAll('.addon-qty');
      for (const input of qtyInputs) {
          const qty = parseInt(input.value);
          if (qty > 0) {
              const card = input.closest('.g-card');
              const vid = await getFirstVariantIdByHandle(card.dataset.handle);
              if (vid) {
                  addItems.push({ 
                      id: Number(vid), 
                      quantity: qty, 
                      properties: { _parent: String(mainVariantId), _config_id: configurationId } 
                  });
              }
          }
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ items: addItems })
      });
      if(res.ok){
        window.location.href = '/cart';
      } else {
        const err = await res.json().catch(()=>({}));
        alert(err?.message || 'Fehler: Artikel konnte nicht in den Warenkorb gelegt werden.');
      }
    } catch(err) {
      alert('Ein Netzwerkfehler ist aufgetreten.');
    } finally {
      allButtons.forEach(btn => btn.disabled = false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exklusiv"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dataEl = document.getElementById('exklusiv-variant-data');
  if(!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const variants = data.variants;

  // --- START SVG ICONS (FIX 7060) ---
  const zoomStandard = "0 220 1080 680"; 
  const zoomVertical = "200 100 680 880"; 
  const zoomDetail   = "300 250 480 600"; 
  const zoomBox      = "0 0 100 75";

  const svgIcons = {
depth: {
  '2500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="399.67 412.22 595.16 360.45 882.67 414.55 671.51 478.35 399.67 412.22"/><path fill="#f6f6f6" d="m595.24,362.5l279.03,52.5-202.81,61.28-263.66-64.14,187.44-49.64m-.15-4.1l-203.54,53.9,280.02,68.12,219.52-66.33-296-55.7h0Z"/></g><polygon points="671.57 492.41 391.55 424.29 391.55 412.29 671.57 480.41 671.57 492.41"/><polygon points="891.09 426.1 671.57 492.42 671.57 480.42 891.09 414.1 891.09 426.1"/><rect x="664.07" y="480.41" width="15" height="230"/><rect x="391.55" y="412.29" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="559.76" y1="453.21" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="504.11" y1="439.68" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="448.49" y1="426.15" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="615.42" y1="466.75" x2="827.82" y2="404.16"/></svg>`,

  '3000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="370.67 420.66 595.16 360.45 882.66 414.54 642.56 486.81 370.67 420.66"/><path fill="#f6f6f6" d="m595.24,362.5l278.98,52.49-231.72,69.74-263.76-64.17,216.5-58.07m-.16-4.1l-232.49,62.36,280.02,68.12,248.47-74.78-296-55.7h0Z"/></g><polygon points="642.62 500.88 362.6 432.76 362.6 420.76 642.62 488.88 642.62 500.88"/><polygon points="891.09 426.1 642.62 500.88 642.62 488.88 891.09 414.1 891.09 426.1"/><rect x="635.12" y="488.88" width="15" height="230"/><rect x="362.6" y="420.76" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="530.59" y1="461.62" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="474.59" y1="448" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="418.59" y1="434.38" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="586.59" y1="475.25" x2="827.82" y2="404.16"/></svg>`,

  '3500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="339.57 429.87 595.17 360.45 882.65 414.54 611.51 496.02 339.57 429.87"/><path fill="#f6f6f6" d="m595.25,362.5l278.96,52.49-262.76,78.96-263.86-64.19,247.65-67.26m-.16-4.1l-263.54,71.57,280.02,68.12,279.52-84-296-55.7h0Z"/></g><polygon points="611.57 510.09 331.55 441.97 331.55 429.97 611.57 498.09 611.57 510.09"/><polygon points="891.09 426.1 611.57 510.09 611.57 498.09 891.09 414.1 891.09 426.1"/><rect x="604.07" y="498.09" width="15" height="230"/><rect x="331.55" y="429.97" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="499.04" y1="470.72" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="442.65" y1="457" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="386.23" y1="443.28" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="555.41" y1="484.43" x2="827.82" y2="404.16"/></svg>`,

  '4000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="309.52 439.15 595.17 360.45 882.66 414.55 581.51 505.32 309.52 439.15"/><path fill="#f6f6f6" d="m595.26,362.5l278.98,52.5-292.79,88.25-263.97-64.22,277.77-76.52m-.17-4.1l-293.54,80.87,280.02,68.12,309.52-93.29-296-55.7h0Z"/></g><polygon points="581.57 519.39 301.55 451.27 301.55 439.27 581.57 507.39 581.57 519.39"/><polygon points="891.09 426.1 581.57 519.39 581.57 507.39 891.09 414.1 891.09 426.1"/><rect x="574.07" y="507.39" width="15" height="230"/><rect x="301.55" y="439.27" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="467.83" y1="479.72" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="411.05" y1="465.9" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="354.22" y1="452.08" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="524.57" y1="493.52" x2="827.82" y2="404.16"/></svg>`
},
  width: {
  '5060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="393.16 426.13 620.17 365.25 857.34 409.9 620.03 481.32 393.16 426.13"/><path fill="#f6f6f6" d="m620.24,367.29l228.67,43.06-228.94,68.9-218.74-53.22,219.01-58.74m-.16-4.1l-235,63.03,235,57.17,245.68-73.94-245.68-46.26h0Z"/></g><polygon points="620.09 495.4 385.09 438.23 385.09 426.23 620.09 483.4 620.09 495.4"/><polygon points="866.09 421.47 620.09 495.4 620.09 483.4 866.09 409.47 866.09 421.47"/><rect x="612.59" y="483.4" width="15" height="230"/><rect x="385.09" y="426.23" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="561.34" y1="469.1" x2="800.18" y2="399.22"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="502.59" y1="454.81" x2="738.83" y2="387.57"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="443.84" y1="440.42" x2="676.56" y2="375.8"/></svg>`,

  '6060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="370.67 420.66 595.17 360.45 882.66 414.54 642.56 486.81 370.67 420.66"/><path fill="#f6f6f6" d="m595.24,362.5l278.98,52.49-231.72,69.74-263.76-64.17,216.5-58.07m-.16-4.1l-232.49,62.36,280.02,68.12,248.47-74.78-296-55.7h0Z"/></g><polygon points="642.62 500.88 362.6 432.76 362.6 420.76 642.62 488.88 642.62 500.88"/><polygon points="891.09 426.1 642.62 500.88 642.62 488.88 891.09 414.1 891.09 426.1"/><rect x="635.12" y="488.88" width="15" height="230"/><rect x="362.6" y="420.76" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="530.59" y1="461.62" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="474.59" y1="448" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="418.59" y1="434.38" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="586.59" y1="475.25" x2="827.82" y2="404.16"/></svg>`,

  '7060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="348.11 415.17 570.17 355.61 907.66 419.17 664.89 492.24 348.11 415.17"/><path fill="#f6f6f6" d="m570.24,357.66l328.99,61.96-234.39,70.55-308.65-75.09,214.06-57.41m-.16-4.1l-230.05,61.7,324.91,79.04,251.14-75.59-346-65.16h0Z"/></g><polygon points="664.95 506.31 340.04 427.27 340.04 415.27 664.95 494.31 664.95 506.31"/><polygon points="916.09 430.73 664.95 506.31 664.95 494.31 916.09 418.73 916.09 430.73"/><rect x="657.45" y="494.31" width="15" height="230"/><rect x="494.99" y="456.61" width="15" height="211.39"/><rect x="340.04" y="415.27" width="15" height="200.17"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="502.49" y1="454.79" x2="738.42" y2="387.38"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="448.41" y1="441.63" x2="681.03" y2="376.45"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="394.25" y1="428.45" x2="623.34" y2="365.6"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="556.73" y1="467.98" x2="796.65" y2="398.07"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="610.89" y1="481.16" x2="853.91" y2="409.04"/></svg>`,
},
    polySpecs: {
      'Klar': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><line fill="none" stroke="#000" stroke-width="15" x1="704.17" y1="674.72" x2="607.52" y2="771.37"/><line fill="none" stroke="#000" stroke-width="15" x1="722.57" y1="730.67" x2="663.48" y2="789.76"/><line fill="none" stroke="#000" stroke-width="15" x1="372.05" y1="423.21" x2="468.71" y2="326.55"/><line fill="none" stroke="#000" stroke-width="15" x1="353.66" y1="367.25" x2="412.75" y2="308.16"/></svg>`,
      'Opal': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><g stroke="#000" stroke-width="5"><line x1="766.43" y1="210.83" x2="314.48" y2="869.39"/><line x1="766.57" y1="245.83" x2="340.7" y2="866.38"/><line x1="766.7" y1="280.83" x2="366.92" y2="863.37"/><line x1="766.83" y1="315.83" x2="393.13" y2="860.35"/><line x1="766.96" y1="350.83" x2="419.35" y2="857.34"/><line x1="767.09" y1="385.83" x2="445.57" y2="854.33"/><line x1="767.22" y1="420.83" x2="471.79" y2="851.32"/><line x1="767.35" y1="455.83" x2="498.01" y2="848.3"/><line x1="767.48" y1="490.84" x2="524.23" y2="845.29"/><line x1="767.61" y1="525.84" x2="550.45" y2="842.28"/><line x1="767.74" y1="560.84" x2="576.66" y2="839.27"/><line x1="767.87" y1="595.84" x2="602.88" y2="836.26"/><line x1="768.01" y1="630.84" x2="629.1" y2="833.24"/><line x1="768.14" y1="665.84" x2="655.32" y2="830.23"/><line x1="768.27" y1="700.84" x2="681.54" y2="827.22"/><line x1="768.4" y1="735.84" x2="707.76" y2="824.21"/><line x1="768.53" y1="770.85" x2="733.98" y2="821.19"/><line x1="314.48" y1="869.39" x2="766.43" y2="210.83"/><line x1="314.48" y1="834.39" x2="740.35" y2="213.84"/><line x1="314.48" y1="799.39" x2="714.26" y2="216.85"/><line x1="314.48" y1="764.39" x2="688.17" y2="219.86"/><line x1="314.48" y1="729.39" x2="662.08" y2="222.88"/><line x1="314.48" y1="694.39" x2="636" y2="225.89"/><line x1="314.48" y1="659.38" x2="609.91" y2="228.9"/><line x1="314.48" y1="624.38" x2="583.82" y2="231.91"/><line x1="314.48" y1="589.38" x2="557.73" y2="234.93"/><line x1="314.48" y1="554.38" x2="531.64" y2="237.94"/><line x1="314.48" y1="519.38" x2="505.56" y2="240.95"/><line x1="314.48" y1="484.38" x2="479.47" y2="243.96"/><line x1="314.48" y1="449.38" x2="453.38" y2="246.97"/><line x1="314.48" y1="414.37" x2="427.29" y2="249.99"/><line x1="314.48" y1="379.37" x2="401.21" y2="253"/><line x1="314.48" y1="344.37" x2="375.12" y2="256.01"/><line x1="314.48" y1="309.37" x2="349.03" y2="259.02"/></g></svg>`,
      'Solar Control': `<svg viewBox="0 0 1080 1080"><polyline fill="none" stroke="#000" stroke-width="15" points="607.53 206.24 790 182.57 790 832.57 290 897.43 290 247.43"/><g><circle fill="none" stroke="#000" stroke-width="15" cx="464.64" cy="267.56" r="61.04"/><line fill="none" stroke="#000" stroke-width="15" x1="464.64" y1="355.61" x2="464.64" y2="391.61"/><line fill="none" stroke="#000" stroke-width="15" x1="464.64" y1="143.51" x2="464.64" y2="179.51"/><line fill="none" stroke="#000" stroke-width="15" x1="376.59" y1="267.56" x2="340.59" y2="267.56"/><line fill="none" stroke="#000" stroke-width="15" x1="588.69" y1="267.56" x2="552.69" y2="267.56"/><line fill="none" stroke="#000" stroke-width="15" x1="402.38" y1="329.82" x2="376.92" y2="355.28"/><line fill="none" stroke="#000" stroke-width="15" x1="552.36" y1="179.84" x2="526.9" y2="205.3"/><line fill="none" stroke="#000" stroke-width="15" x1="402.38" y1="205.3" x2="376.92" y2="179.84"/><line fill="none" stroke="#000" stroke-width="15" x1="552.36" y1="355.28" x2="526.9" y2="329.82"/></g><g stroke="#000" stroke-width="5"><line x1="768.53" y1="210.83" x2="316.57" y2="869.39"/><line x1="768.53" y1="245.83" x2="342.66" y2="866.38"/><line x1="768.53" y1="280.83" x2="368.75" y2="863.37"/><line x1="768.53" y1="315.83" x2="394.84" y2="860.35"/><line x1="768.53" y1="350.83" x2="420.92" y2="857.34"/><line x1="768.53" y1="385.83" x2="447.01" y2="854.33"/><line x1="768.53" y1="420.83" x2="473.1" y2="851.32"/><line x1="768.53" y1="455.83" x2="499.19" y2="848.3"/><line x1="768.53" y1="490.84" x2="525.27" y2="845.29"/><line x1="768.53" y1="525.84" x2="551.36" y2="842.28"/><line x1="768.53" y1="560.84" x2="577.45" y2="839.27"/><line x1="768.53" y1="595.84" x2="603.54" y2="836.26"/><line x1="768.53" y1="630.84" x2="629.63" y2="833.24"/><line x1="768.53" y1="665.84" x2="655.71" y2="830.23"/><line x1="768.53" y1="700.84" x2="681.8" y2="827.22"/><line x1="768.53" y1="735.84" x2="707.89" y2="824.21"/><line x1="768.53" y1="770.85" x2="733.98" y2="821.19"/><line x1="316.57" y1="869.39" x2="768.53" y2="210.83"/><line x1="316.44" y1="834.39" x2="742.31" y2="213.84"/><line x1="316.31" y1="799.39" x2="716.09" y2="216.85"/><line x1="316.18" y1="764.39" x2="689.87" y2="219.86"/><line x1="316.05" y1="729.39" x2="663.65" y2="222.88"/><line x1="315.92" y1="694.39" x2="504.52" y2="418.61"/><line x1="315.79" y1="659.38" x2="478.3" y2="421.63"/><line x1="315.66" y1="624.38" x2="452.08" y2="424.64"/><line x1="315.53" y1="589.38" x2="425.87" y2="427.65"/><line x1="315.39" y1="554.38" x2="399.65" y2="430.66"/><line x1="315.26" y1="519.38" x2="394.43" y2="400.48"/><line x1="315.13" y1="484.38" x2="368.22" y2="403.49"/></g></svg>`,
      'Ultra-klar': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><line fill="none" stroke="#000" stroke-width="15" x1="704.17" y1="674.72" x2="607.52" y2="771.37"/><line fill="none" stroke="#000" stroke-width="15" x1="722.57" y1="730.67" x2="663.48" y2="789.76"/><line fill="none" stroke="#000" stroke-width="15" x1="372.05" y1="423.21" x2="468.71" y2="326.55"/><line fill="none" stroke="#000" stroke-width="15" x1="353.66" y1="367.25" x2="412.75" y2="308.16"/><path fill="none" stroke="#000" stroke-width="5" d="m712.1,369.7c-38.4,7.88-43.67,14.27-50.17,60.86-6.5-46.58-11.77-52.97-50.17-60.86,38.4-7.88,43.67-14.27,50.17-60.86,6.5,46.58,11.77,52.97,50.17,60.86Z"/><path fill="none" stroke="#000" stroke-width="5" d="m541.88,626.78c-38.4,7.88-43.67,14.27-50.17,60.86-6.5-46.58-11.77-52.97-50.17-60.86,38.4-7.88,43.67-14.27,50.17-60.86,6.5,46.58,11.77,52.97,50.17,60.86Z"/></svg>`
    },
    addons: {
      'rund': `<svg viewBox="${zoomStandard}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m340,260h285.82c5.15,4.26,114.18,98.11,114.18,280,0,8.37-2.28,187.49-114.18,280h-285.82"/></svg>`,
      'klassisch': `<svg viewBox="${zoomStandard}"><polyline fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" points="342.37 257.63 742.37 257.63 742.37 349.96 652.37 495.52 652.37 578.87 561.61 723.26 561.61 817.63 342.37 817.63"/></svg>`,
      'beton': `<svg viewBox="${zoomBox}"><rect x="15" y="25" width="70" height="40" fill="#e0e0e0" stroke="#888" stroke-width="3"/><path d="M15 25 L 30 10 L 100 10 L 85 25" fill="#f0f0f0" stroke="#888" stroke-width="3"/><path d="M85 25 L 85 65 L 100 50 L 100 10" fill="#ccc" stroke="#888" stroke-width="3"/></svg>`,
      'beton_abfluss': `<svg viewBox="${zoomBox}"><rect x="15" y="25" width="70" height="40" fill="#e0e0e0" stroke="#888" stroke-width="3"/><path d="M15 25 L 30 10 L 100 10 L 85 25" fill="#f0f0f0" stroke="#888" stroke-width="3"/><circle cx="50" cy="45" r="10" fill="#333" stroke="#888" stroke-width="2"/></svg>`,
      'bohrer': `<svg viewBox="${zoomBox}"><rect x="20" y="30" width="60" height="15" fill="#aaa" stroke="#666" stroke-width="2"/><path d="M80 30 L 95 37.5 L 80 45" fill="#666"/><rect x="5" y="25" width="15" height="25" fill="#444"/></svg>`,
      'heizung': `<svg viewBox="${zoomBox}"><rect x="10" y="20" width="80" height="20" rx="5" fill="#333"/><path d="M15 50 Q 25 40, 35 50 T 55 50 T 75 50 T 95 50" stroke="orange" stroke-width="3" fill="none"/><path d="M15 60 Q 25 50, 35 60 T 55 60 T 75 60 T 95 60" stroke="orange" stroke-width="3" fill="none"/></svg>`,
      'montage': `<svg viewBox="${zoomBox}"><rect x="20" y="20" width="60" height="40" fill="#d2b48c" stroke="#8b4513" stroke-width="2"/><path d="M20 20 L 50 40 L 80 20" stroke="#8b4513" stroke-width="2"/><path d="M50 20 L 50 60" stroke="#8b4513" stroke-width="2"/></svg>`,
      'stift': `<svg viewBox="${zoomBox}"><rect x="30" y="20" width="40" height="40" fill="#333" stroke="#000"/><path d="M30 60 L 50 75 L 70 60" fill="#555"/><rect x="30" y="5" width="40" height="15" fill="#888"/></svg>`,
      'profil': `<svg viewBox="${zoomBox}"><rect x="30" y="10" width="20" height="60" fill="#ccc" stroke="#666" stroke-width="2"/><rect x="50" y="50" width="30" height="20" fill="#ccc" stroke="#666" stroke-width="2"/></svg>`,
      'led': `<svg viewBox="${zoomDetail}"><rect fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x="350" y="718.89" width="357.83" height="101.11" rx=".9" ry=".9"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m529.17,376.5h10.69c59.87,0,108.47,48.6,108.47,108.47v234.59h-227.63v-234.59c0-59.87,48.6-108.47,108.47-108.47Z"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m540,425.03c-5.09-.01-31.13.44-52.39,21.49-20.74,20.53-22.1,45.97-22.27,51.29"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m532.41,583.47h4.22c23.63,0,42.82,19.19,42.82,42.82v92.6h-89.86v-92.6c0-23.63,19.19-42.82,42.82-42.82Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="540" y1="260" x2="540" y2="339.13"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="740" y1="331.9" x2="679.93" y2="382.77"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="340" y1="331.9" x2="400.07" y2="382.77"/></svg>`,
      'keilfenster': `<svg viewBox="${zoomVertical}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m830,473.86H250v-212.55c0-.8.55-1.41,1.16-1.29l578,118.86c.49.1.84.65.84,1.29v93.69Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="473.86" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="473.86" x2="250" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="336.94" y1="321.65" x2="281.89" y2="355.61"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="375.67" y1="335.45" x2="320.62" y2="369.4"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="723.12" y1="397.27" x2="668.07" y2="431.22"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="761.85" y1="411.06" x2="706.8" y2="445.02"/><path d="m830,473.86H250v-212.55c0-.8.55-1.41,1.16-1.29l578,118.86c.49.1.84.65.84,1.29v93.69Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="473.86" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="473.86" x2="250" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="336.94" y1="321.65" x2="281.89" y2="355.61"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="375.67" y1="335.45" x2="320.62" y2="369.4"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="723.12" y1="397.27" x2="668.07" y2="431.22"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="761.85" y1="411.06" x2="706.8" y2="445.02"/></svg>`,
      'seitenwand': `<svg viewBox="${zoomVertical}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m830,435.4H250v-174.33c0-.66.55-1.16,1.16-1.06l578,97.49c.49.08.84.53.84,1.06v76.84Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="435.4" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="435.4" x2="250" y2="820"/><path d="m670.43,447.81v347.19h-407.92v-347.19h407.92m25-25H237.51v397.19h457.92v-397.19h0Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="355.5" y1="487.97" x2="300.45" y2="521.92"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="394.23" y1="501.76" x2="339.18" y2="535.71"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="355.5" y1="487.97" x2="300.45" y2="521.92"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="588.32" y1="709.01" x2="533.27" y2="742.97"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="627.06" y1="722.81" x2="572" y2="756.76"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="588.32" y1="709.01" x2="533.27" y2="742.97"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="627.06" y1="722.81" x2="572" y2="756.76"/></svg>`,
      'schlagduebel': `<svg viewBox="400 200 280 680"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m462.5,260h220v6.9c0,26.92-21.85,48.77-48.77,48.77h-122.46c-26.92,0-48.77-21.85-48.77-48.77v-6.9h0Z"/><rect fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x="540" y="317.31" width="65" height="222.69"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="360.7" x2="605" y2="404.39"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="406.81" x2="605" y2="450.5"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="452.92" x2="605" y2="496.61"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m587.32,820h-29.73c-2.86,0-5.26-2.01-5.55-4.66l-28.68-265.77c-.46-4.25,3.14-7.94,7.74-7.94h82.8c4.6,0,8.2,3.69,7.74,7.94l-28.78,265.77c-.29,2.64-2.68,4.65-5.55,4.65Z"/></svg>`,
      'poly': `<svg viewBox="0 0 1080 1080"><path fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" d="m789.2,412.62h-498.4c-.47,0-.87.32-.98.78l-49.55,219.14c-.14.63.33,1.22.98,1.22h597.5c.64,0,1.12-.6.98-1.22l-49.55-219.14c-.1-.46-.51-.78-.98-.78Z"/><polyline fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" points="840 633.76 840 692.54 240 692.54 240 633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="540" y1="412.62" x2="540" y2="633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="621.53" y1="413.45" x2="648.47" y2="632.93"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="458.47" y1="413.45" x2="431.53" y2="632.93"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="705.8" y1="414.3" x2="744.2" y2="632.08"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="539.46" y1="633.21" x2="539.46" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="646.91" y1="633.21" x2="646.91" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="743.96" y1="633.21" x2="743.96" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="337" y1="633.21" x2="337" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="434.04" y1="633.21" x2="434.04" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="374.2" y1="414.3" x2="335.8" y2="632.08"/></svg>`,
      'glas': `<svg viewBox="0 0 1080 1080"><path fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" d="m789.2,412.62h-498.4c-.47,0-.87.32-.98.78l-49.55,219.14c-.14.63.33,1.22.98,1.22h597.5c.64,0,1.12-.6.98-1.22l-49.55-219.14c-.1-.46-.51-.78-.98-.78Z"/><polyline fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" points="840 633.76 840 692.54 240 692.54 240 633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="727.18" y1="540" x2="672.13" y2="573.96"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="765.92" y1="553.79" x2="710.87" y2="587.75"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="386.82" y1="451.78" x2="331.77" y2="485.73"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="425.56" y1="465.57" x2="370.51" y2="499.52"/></svg>`
    },
colors: {
  'RAL9001': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#F2EAD6" stroke="#ddd" stroke-width="2"/></svg>`,
  'RAL7024': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#3f4852"/></svg>`,
  'RAL9016': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#FFFFFF" stroke="#E5E7EB" stroke-width="3"/></svg>`,
  'RAL9005': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#1C1C1C"/></svg>`
}
  };
  const fallbackSVG = `<svg viewBox="0 0 100 75"><rect width="100" height="75" fill="#f5f5f5"/><text x="50" y="50" font-size="20" text-anchor="middle" dominant-baseline="middle" fill="#ccc">?</text></svg>`;
  // --- END SVG ICONS ---


  const varInput = document.getElementById('exklusiv-variant-id');
  const form = document.getElementById('exklusiv-product-form');
  
  const getAllButtons = () => {
    if(!form) return [];
    const btnsInside = Array.from(form.querySelectorAll('button[type="submit"]'));
    const btnsOutside = Array.from(document.querySelectorAll('button[type="submit"][form="exklusiv-product-form"]'));
    return [...btnsInside, ...btnsOutside];
  };

  const titW = document.getElementById('tit-width');
  const titD = document.getElementById('tit-depth');
  const titR = document.getElementById('tit-roof');
  const titC = document.getElementById('tit-color');
  const titA = document.getElementById('tit-addons');
  const colorInput = document.getElementById('prop-color');
  const pcWrap = document.getElementById('poly-subtype-wrap');
  const warnGlass = document.getElementById('warn-glass-span');
  const warnBeam  = document.getElementById('warn-beam');
  const reinfChk  = document.getElementById('prop-reinf');
  const accItems = [...document.querySelectorAll('.g-acc__item')];
  
  const sumPriceLine = document.getElementById('sum-price-line');
  const sumAddonsPrice = document.getElementById('sum-addons-price');
  const sumPriceFinal = document.getElementById('sum-price-final');
  
  const sumDimensionsWrap = document.getElementById('sum-dimensions-wrap');
  const sumWidth = document.getElementById('sum-width');
  const sumDepth = document.getElementById('sum-depth');
  const sumColorWrap = document.getElementById('sum-color-wrap');
  const sumColor = document.getElementById('sum-color');
  const sumRoofWrap = document.getElementById('sum-roof-wrap');
  const sumRoof = document.getElementById('sum-roof');
  const sumPcSpec = document.getElementById('sum-pc-spec');
  const sumAddonsWrap = document.getElementById('sum-addons-wrap');
  const sumAddonsList = document.getElementById('sum-addons-list');
  const validationMessage = document.getElementById('exklusiv-validation-message');

  const footerSummaryText = document.getElementById('footer-summary-text');
  const footerPriceFinal = document.getElementById('footer-price-final');
  
  const addonPriceCache = {};
  
  const fetchProductPrice = async (handle) => {
    if (addonPriceCache[handle]) return addonPriceCache[handle];
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return 0;
      const product = await response.json();
      const price = product.variants[0].price;
      addonPriceCache[handle] = price;
      return price;
    } catch (e) { return 0; }
  };

  // NEW: Updates the visible price tag on all addon cards
  const updateUIAddonPrices = async () => {
    const targets = form.querySelectorAll('[data-handle]'); 
    for(const t of targets){
       const handle = t.dataset.handle;
       const price = await fetchProductPrice(handle);
       const card = t.closest('.g-card');
       const priceEl = card ? card.querySelector('.g-card__price') : null;
       if(priceEl) priceEl.textContent = fmt(price);
    }
  };
  
  function generateChoiceCards(containerId, inputName, options, type) {
    const container = document.getElementById(containerId);
    if (!container) return;
    
    container.innerHTML = options.map(opt => {
      const iconSvg = (svgIcons[type] && svgIcons[type][opt]) ? svgIcons[type][opt] : fallbackSVG;
      return `
        <label class="g-card">
          <input type="radio" name="${inputName}" value="${opt}" class="visually-hidden">
          <div class="g-card__thumb">${iconSvg}</div>
          <div class="g-card__label">${opt} mm</div>
        </label>
      `;
    }).join('');
  }
  const unique = arr => [...new Set(arr)];
  const widths = unique(variants.map(v => v.option1)).sort();
  const depths = unique(variants.map(v => v.option2)).sort((a,b)=>parseInt(a)-parseInt(b));

  generateChoiceCards('width-options-grid', 'opt-width', widths, 'width');
  generateChoiceCards('depth-options-grid', 'opt-depth', depths, 'depth');

  function updateStaticIcon(selector, iconKey, type) {
    if(selector) {
      const el = form.querySelector(selector);
      if(el) {
        const card = el.classList.contains('g-card') ? el : el.closest('.g-card');
        const thumb = card?.querySelector('.g-card__thumb');
        if(thumb && svgIcons[type] && svgIcons[type][iconKey]) {
          thumb.innerHTML = svgIcons[type][iconKey];
        }
      }
    }
  }
  
  const iconCards = form.querySelectorAll('.g-card__thumb[data-icon]');
  iconCards.forEach(thumb => {
      const iconKey = thumb.dataset.icon;
      if(svgIcons.addons[iconKey]) {
          thumb.innerHTML = svgIcons.addons[iconKey];
      }
  });


updateStaticIcon('button[data-color="RAL9016"]', 'RAL9016', 'colors');
updateStaticIcon('button[data-color="RAL7024"]', 'RAL7024', 'colors');
updateStaticIcon('button[data-color="RAL9005"]', 'RAL9005', 'colors');

updateStaticIcon('input[value="Klar"]', 'Klar', 'polySpecs');
updateStaticIcon('input[value="Opal"]', 'Opal', 'polySpecs');

  updateStaticIcon('input[value="Polycarbonat"]', 'poly', 'addons');
  updateStaticIcon('input[value="Glas"]', 'glas', 'addons');
  
  // MAIN ACCORDION LOGIC
  accItems.forEach((item) => {
    const summary = item.querySelector('.g-acc__summary');
    const content = item.querySelector('.g-acc__body');
    
    // Initial State
    if (item.hasAttribute('open')) { 
       content.style.maxHeight = 'none'; // Allow dynamic height for pre-opened items
    } else { 
       content.style.maxHeight = '0px'; 
    }
    
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (item.hasAttribute('open')) {
        // Closing
        content.style.maxHeight = content.scrollHeight + 'px'; // Set pixel height first for transition
        setTimeout(() => { content.style.maxHeight = '0px'; }, 10);
        setTimeout(() => { item.removeAttribute('open'); }, 500); // Wait for transition
      } else {
        // Opening
        item.setAttribute('open', '');
        content.style.maxHeight = content.scrollHeight + 'px';
        // After transition, remove max-height constraint to allow inner accordions to expand
        setTimeout(() => { 
            if(item.hasAttribute('open')) content.style.maxHeight = 'none'; 
        }, 500);
      }
    });
  });

  // SUB ACCORDION LOGIC
  const subItems = document.querySelectorAll('.g-acc__sub');
  subItems.forEach((item) => {
    const summary = item.querySelector('.g-acc__sub-summary');
    const content = item.querySelector('.g-acc__sub-body');

    if (!item.hasAttribute('open')) { content.style.maxHeight = '0px'; }

    summary.addEventListener('click', (e) => {
        e.preventDefault();
        const parentBody = item.closest('.g-acc__body'); // The parent container

        if (item.hasAttribute('open')) {
            // Closing sub-item
            content.style.maxHeight = content.scrollHeight + 'px';
            setTimeout(() => { content.style.maxHeight = '0px'; }, 10);
            setTimeout(() => { item.removeAttribute('open'); }, 300);
        } else {
            // Opening sub-item
            item.setAttribute('open', '');
            content.style.maxHeight = content.scrollHeight + 'px';
            setTimeout(() => { 
                if(item.hasAttribute('open')) content.style.maxHeight = 'none'; 
            }, 300);
        }
    });
  });

  const closeCurrentStep = (el) => {
    const currentItem = el.closest('.g-acc__item');
    if (currentItem && currentItem.hasAttribute('open')) { 
        // We trigger click to close, so it animates
        currentItem.querySelector('.g-acc__summary').click(); 
    }
  };
  
  const flashElement = (el) => {
    el.classList.add('flash-animation');
    setTimeout(() => { el.classList.remove('flash-animation'); }, 700);
  };

  const getSelectedValue = name => form.querySelector(`input[name="${name}"]:checked`)?.value || '';
  const fmt = (c) => (typeof Shopify!=='undefined'&&Shopify.formatMoney)? Shopify.formatMoney(c):(c/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'});

  function setColor(val, labelText){
    const colorCards = form.querySelectorAll('#color-swatches .g-card');
    colorInput.value = val || '';
    colorCards.forEach(c => {
      const active = c.dataset.color === val;
      c.setAttribute('aria-pressed', String(active));
      c.setAttribute('aria-checked', String(active));
    });
    const newColorText = labelText || (val || '–');
    if (titC.textContent !== newColorText) {
      titC.textContent = newColorText;
      flashElement(titC);
    }
    validateAndRender();
  }
  
  async function validateAndRender(){
    const w = getSelectedValue('opt-width');
    const d = getSelectedValue('opt-depth');
    const r = getSelectedValue('opt-roof');
    let pcSubtype = getSelectedValue('properties[pc_subtype]');

if (r === 'Polycarbonat') {
  const subtypes = ['Opal', 'Klar'];

  subtypes.forEach(subtype => {
    const input = form.querySelector(`input[name="properties[pc_subtype]"][value="${subtype}"]`);
    if (!input) return;

    const variantExists = variants.some(
      v => v.option1 == w && v.option2 == d && v.option3 === `Polycarbonat ${subtype}`
    );

    const card = input.closest('.g-card');
    if (card) {
      card.classList.toggle('option-disabled', !variantExists);
    }

    if (!variantExists && input.checked) {
      input.checked = false;
      pcSubtype = '';
    }
  });
}

    let variantOption3 = r;
    if (r === 'Polycarbonat') {
        variantOption3 = `Polycarbonat ${pcSubtype}`;
    }

    const variant = (w && d && variantOption3) ? 
        variants.find(v => v.option1 == w && v.option2 == d && v.option3 == variantOption3) 
        : null;
    
    const newWidthText = w ? `${w} mm` : '–';
    if (titW.textContent !== newWidthText) { titW.textContent = newWidthText; flashElement(titW); }
    const newDepthText = d ? `${d} mm` : '–';
    if (titD.textContent !== newDepthText) { titD.textContent = newDepthText; flashElement(titD); }
    const newRoofText = r || '–';
    if (titR.textContent !== newRoofText) { titR.textContent = newRoofText; flashElement(titR); }

    sumDimensionsWrap.classList.toggle('hidden', !w || !d);
    sumWidth.textContent = w;
    sumDepth.textContent = d;
    sumColorWrap.classList.toggle('hidden', !colorInput.value);
    sumColor.textContent = colorInput.value;
    sumRoofWrap.classList.toggle('hidden', !r);
    sumRoof.textContent = r;
    sumPcSpec.classList.toggle('hidden', r !== 'Polycarbonat');

    const zier = getSelectedValue('addon-zierleiste');
    const qtyInputs = form.querySelectorAll('.addon-qty');
    let hasQtyAddons = false;
    let addonTextList = [];
    if(zier) addonTextList.push(zier);

    qtyInputs.forEach(input => {
        if(parseInt(input.value) > 0) {
            hasQtyAddons = true;
            const card = input.closest('.g-card');
            const label = card.querySelector('.g-card__label').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            addonTextList.push(`${input.value}x ${label}`);
        }
    });

    sumAddonsWrap.classList.toggle('hidden', addonTextList.length === 0);
    sumAddonsList.textContent = addonTextList.join(', ');


    
    const isPoly = r === 'Polycarbonat';
    const wasHiddenPoly = pcWrap.classList.contains('hidden');
    pcWrap.classList.toggle('hidden', !isPoly);
    
    // Parent height recalculation for poly wrapper
    if ((isPoly && wasHiddenPoly) || (!isPoly && !wasHiddenPoly)) {
      setTimeout(() => {
        const detailsItem = pcWrap.closest('.g-acc__item');
        if (detailsItem && detailsItem.hasAttribute('open')) {
           // Since we use max-height: none for open items now, this might not be strictly needed,
           // but good for safety during transitions.
        }
      }, 10);
    }
    
    if (variant && r === 'Glas') {
      const span = variant.metafields.max_post_span_mm.value || 0;
      warnGlass.textContent = span ? `Hinweis: Bei Glas beträgt der maximale Pfostenabstand ${span} mm.` : '';
      warnGlass.classList.toggle('hidden', !span);
    } else { warnGlass.classList.add('hidden'); }

    const is6000 = d === '6000';
    const wasHiddenBeam = warnBeam.classList.contains('hidden');
    warnBeam.classList.toggle('hidden', !is6000);
    if (!is6000 && reinfChk) reinfChk.checked = false;
    
let basePrice = 0;

if (variant) {
  varInput.value = variant.id;
  basePrice = variant.price;
} else {
  varInput.value = '';
}



    let addonTotal = 0;
    
    if(zier) {
        const r = form.querySelector('input[name="addon-zierleiste"]:checked');
        const price = await fetchProductPrice(r.dataset.handle);
        addonTotal += price; 
    }

    for (const input of qtyInputs) {
      const qty = parseInt(input.value);
      if (qty > 0) {
        const card = input.closest('.g-card');
        const price = await fetchProductPrice(card.dataset.handle);
        addonTotal += (price * qty);
      }
    }

    const finalPrice = basePrice + addonTotal;
    sumPriceLine.textContent = fmt(basePrice);
    sumAddonsPrice.textContent = fmt(addonTotal);
    sumPriceFinal.textContent = fmt(finalPrice);
    footerPriceFinal.textContent = fmt(finalPrice);
    
    const summaryItems = [w ? `${w}x${d}mm` : null, colorInput.value, r, zier, hasQtyAddons ? `Zubehör` : null].filter(Boolean);
    footerSummaryText.textContent = summaryItems.join(' / ');

let totalAddonCount = 0;
qtyInputs.forEach(i => totalAddonCount += parseInt(i.value));
if (zier) { totalAddonCount += 1; }

if (titA) {
  const newAddonText = totalAddonCount > 0 ? `${totalAddonCount} Artikel` : '–';
  if (titA.textContent !== newAddonText) {
    titA.textContent = newAddonText;
    flashElement(titA);
  }
}
    
    const missingSelections = [];
    if (!w) missingSelections.push('Breite');
    if (!d) missingSelections.push('Ausfall');
    if (!r) missingSelections.push('Dacheindeckung');
    if (!colorInput.value) missingSelections.push('Farbe');
    
    if (r === 'Polycarbonat' && !pcSubtype) missingSelections.push('Polycarbonat-Ausführung');
    if (d === '6000' && !reinfChk.checked) missingSelections.push('Bestätigung (6000mm)');

    const allButtons = getAllButtons();
    if (missingSelections.length > 0) {
      validationMessage.textContent = `Bitte wählen Sie noch: ${missingSelections.join(', ')}`;
      validationMessage.classList.remove('hidden');
      allButtons.forEach(btn => btn.disabled = true);
    } else {
      validationMessage.classList.add('hidden');
      const shouldDisable = !varInput.value;
      allButtons.forEach(btn => btn.disabled = shouldDisable);
    }
  }

  const resetConfigurator = () => {
    form.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => input.checked = false);
    form.querySelectorAll('.addon-qty').forEach(i => i.value = 0);
    form.querySelectorAll('.g-card').forEach(c => c.classList.remove('has-qty'));
    // Close Sub-Accordions
    subItems.forEach(item => {
        if(item.hasAttribute('open')) {
            item.removeAttribute('open');
            item.querySelector('.g-acc__sub-body').style.maxHeight = '0px';
        }
    });

    setColor('', '');
    validateAndRender();
    accItems.forEach(item => {
      if (!item.hasAttribute('open')) { item.querySelector('.g-acc__summary').click(); }
    });
    document.querySelector('.g-acc__item[data-step="1"]')?.scrollIntoView({ behavior: 'smooth' });
  };

  form.querySelector('#color-swatches').addEventListener('click', (e) => {
    const card = e.target.closest('.g-card');
    if (card) { setColor(card.dataset.color, card.dataset.label); closeCurrentStep(card); }
  });
  
  form.addEventListener('change', (e) => {
    const target = e.target;
    if (target.matches('input[type="radio"]')) {
      const isPolyRadio = target.name === 'opt-roof' && target.value === 'Polycarbonat';
      const is6000mmRadio = target.name === 'opt-depth' && target.value === '6000';
      const inAddons = target.closest('#exklusiv-addons');
      if (!isPolyRadio && !inAddons && !is6000mmRadio) {
        if(target.name !== 'properties[pc_subtype]') {
             closeCurrentStep(target);
        }
      }
    }
    validateAndRender();
  });

  form.addEventListener('click', (e) => {
    if (e.target.matches('.g-qty-btn')) {
        const btn = e.target;
        const wrapper = btn.closest('.g-qty-wrapper');
        const input = wrapper.querySelector('input');
        const card = btn.closest('.g-card');
        let val = parseInt(input.value) || 0;

        if (btn.classList.contains('plus')) {
            val++;
        } else if (btn.classList.contains('minus')) {
            if (val > 0) val--;
        }
        
        input.value = val;
        
        if (val > 0) {
            card.classList.add('has-qty');
        } else {
            card.classList.remove('has-qty');
        }
        
        validateAndRender();
    }
  });


  document.getElementById('addon-zierleiste-clear')?.addEventListener('click', () => {
    const r = form.querySelector('input[name="addon-zierleiste"]:checked');
    if (r) r.checked = false;
    validateAndRender();
  });

  document.getElementById('exklusiv-reset-btn')?.addEventListener('click', resetConfigurator);
  
  const handleAddClick = (e) => {
    const btn = e.currentTarget;
    if (btn && btn.disabled) {
      e.preventDefault();
      const validationMessage = document.getElementById('exklusiv-validation-message');
      if (validationMessage && !validationMessage.classList.contains('hidden')) {
        validationMessage.classList.add('shake-animation');
        setTimeout(() => { validationMessage.classList.remove('shake-animation'); }, 600);
      }
    }
  };
  
  getAllButtons().forEach(btn => {
    btn.addEventListener('click', handleAddClick);
  });

  // Call the new UI updater here
  updateUIAddonPrices();
  validateAndRender();

  async function getFirstVariantIdByHandle(handle){
    try{
      const res = await fetch(`/products/${handle}.js`); if(!res.ok) return null;
      const p = await res.json(); return p?.variants?.[0]?.id || null;
    }catch(e){ return null; }
  }

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const allButtons = getAllButtons();
    if (allButtons.some(btn => btn.disabled)) return;
    
    allButtons.forEach(btn => btn.disabled = true);
    
    try {
      const mainVariantId = varInput.value;
      if(!mainVariantId) return;
      const configurationId = Date.now();
      const formData = new FormData(form);
      const properties = {};
      for (const [k, v] of formData.entries()) {
        if (k.startsWith('properties[')) properties[k.slice(11,-1)] = v;
      }
      properties['_config_id'] = configurationId;
      
      const addItems = [{ id: Number(mainVariantId), quantity: 1, properties }];
      
      const zier = form.querySelector('input[name="addon-zierleiste"]:checked');
      if (zier) {
        const vid = await getFirstVariantIdByHandle(zier.dataset.handle);
        if (vid) addItems.push({ id: Number(vid), quantity: 1, properties: { _parent: String(mainVariantId), _lock_qty: '1', _config_id: configurationId } });
      }

      const qtyInputs = form.querySelectorAll('.addon-qty');
      for (const input of qtyInputs) {
          const qty = parseInt(input.value);
          if (qty > 0) {
              const card = input.closest('.g-card');
              const vid = await getFirstVariantIdByHandle(card.dataset.handle);
              if (vid) {
                  addItems.push({ 
                      id: Number(vid), 
                      quantity: qty, 
                      properties: { _parent: String(mainVariantId), _config_id: configurationId } 
                  });
              }
          }
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ items: addItems })
      });
      if(res.ok){
        window.location.href = '/cart';
      } else {
        const err = await res.json().catch(()=>({}));
        alert(err?.message || 'Fehler: Artikel konnte nicht in den Warenkorb gelegt werden.');
      }
    } catch(err) {
      alert('Ein Netzwerkfehler ist aufgetreten.');
    } finally {
      allButtons.forEach(btn => btn.disabled = false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giallo"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dataEl = document.getElementById('giallo-variant-data');
  if(!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const variants = data.variants;

  // --- START SVG ICONS (FIX 7060) ---
  const zoomStandard = "0 220 1080 680"; 
  const zoomVertical = "200 100 680 880"; 
  const zoomDetail   = "300 250 480 600"; 
  const zoomBox      = "0 0 100 75";

  const svgIcons = {
    depth: {
      '2500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="399.67 412.22 595.16 360.45 882.67 414.55 671.51 478.35 399.67 412.22"/><path fill="#f6f6f6" d="m595.24,362.5l279.03,52.5-202.81,61.28-263.66-64.14,187.44-49.64m-.15-4.1l-203.54,53.9,280.02,68.12,219.52-66.33-296-55.7h0Z"/></g><polygon points="671.57 492.41 391.55 424.29 391.55 412.29 671.57 480.41 671.57 492.41"/><polygon points="891.09 426.1 671.57 492.42 671.57 480.42 891.09 414.1 891.09 426.1"/><rect x="664.07" y="480.41" width="15" height="230"/><rect x="391.55" y="412.29" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="559.76" y1="453.21" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="504.11" y1="439.68" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="448.49" y1="426.15" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="615.42" y1="466.75" x2="827.82" y2="404.16"/></svg>`,
      '3000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="370.67 420.66 595.16 360.45 882.66 414.54 642.56 486.81 370.67 420.66"/><path fill="#f6f6f6" d="m595.24,362.5l278.98,52.49-231.72,69.74-263.76-64.17,216.5-58.07m-.16-4.1l-232.49,62.36,280.02,68.12,248.47-74.78-296-55.7h0Z"/></g><polygon points="642.62 500.88 362.6 432.76 362.6 420.76 642.62 488.88 642.62 500.88"/><polygon points="891.09 426.1 642.62 500.88 642.62 488.88 891.09 414.1 891.09 426.1"/><rect x="635.12" y="488.88" width="15" height="230"/><rect x="362.6" y="420.76" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="530.59" y1="461.62" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="474.59" y1="448" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="418.59" y1="434.38" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="586.59" y1="475.25" x2="827.82" y2="404.16"/></svg>`,
      '3500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="339.57 429.87 595.17 360.45 882.65 414.54 611.51 496.02 339.57 429.87"/><path fill="#f6f6f6" d="m595.25,362.5l278.96,52.49-262.76,78.96-263.86-64.19,247.65-67.26m-.16-4.1l-263.54,71.57,280.02,68.12,279.52-84-296-55.7h0Z"/></g><polygon points="611.57 510.09 331.55 441.97 331.55 429.97 611.57 498.09 611.57 510.09"/><polygon points="891.09 426.1 611.57 510.09 611.57 498.09 891.09 414.1 891.09 426.1"/><rect x="604.07" y="498.09" width="15" height="230"/><rect x="331.55" y="429.97" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="499.04" y1="470.72" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="442.65" y1="457" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="386.23" y1="443.28" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="555.41" y1="484.43" x2="827.82" y2="404.16"/></svg>`,
      '4000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="309.52 439.15 595.17 360.45 882.66 414.55 581.51 505.32 309.52 439.15"/><path fill="#f6f6f6" d="m595.26,362.5l278.98,52.5-292.79,88.25-263.97-64.22,277.77-76.52m-.17-4.1l-293.54,80.87,280.02,68.12,309.52-93.29-296-55.7h0Z"/></g><polygon points="581.57 519.39 301.55 451.27 301.55 439.27 581.57 507.39 581.57 519.39"/><polygon points="891.09 426.1 581.57 519.39 581.57 507.39 891.09 414.1 891.09 426.1"/><rect x="574.07" y="507.39" width="15" height="230"/><rect x="301.55" y="439.27" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="467.83" y1="479.72" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="411.05" y1="465.9" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="354.22" y1="452.08" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="524.57" y1="493.52" x2="827.82" y2="404.16"/></svg>`,
      '6000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="279.49 448.04 595.17 360.45 882.66 414.54 551.51 514.22 279.49 448.04"/><path fill="#f6f6f6" d="m595.26,362.5l278.97,52.49-322.77,97.15-264.03-64.23,307.83-85.41m-.17-4.1l-323.54,89.77,280.02,68.12,339.52-102.2-296-55.7h0Z"/></g><polygon points="551.57 528.29 271.55 460.17 271.55 448.17 551.57 516.29 551.57 528.29"/><polygon points="891.09 426.1 551.57 528.29 551.57 516.29 891.09 414.1 891.09 426.1"/><rect x="544.07" y="516.29" width="15" height="230"/><rect x="271.55" y="448.17" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="437.35" y1="488.51" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="380.19" y1="474.6" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="322.97" y1="460.68" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="494.46" y1="502.4" x2="827.82" y2="404.16"/></svg>`
    },
    width: {
      '3060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="393.16 426.13 620.17 365.25 857.34 409.9 620.03 481.32 393.16 426.13"/><path fill="#f6f6f6" d="m620.24,367.29l228.67,43.06-228.94,68.9-218.74-53.22,219.01-58.74m-.16-4.1l-235,63.03,235,57.17,245.68-73.94-245.68-46.26h0Z"/></g><polygon points="620.09 495.4 385.09 438.23 385.09 426.23 620.09 483.4 620.09 495.4"/><polygon points="866.09 421.47 620.09 495.4 620.09 483.4 866.09 409.47 866.09 421.47"/><rect x="612.59" y="483.4" width="15" height="230"/><rect x="385.09" y="426.23" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="561.34" y1="469.1" x2="800.18" y2="399.22"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="502.59" y1="454.81" x2="738.83" y2="387.57"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="443.84" y1="440.42" x2="676.56" y2="375.8"/></svg>`,
      '4060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="370.67 420.66 595.17 360.45 882.66 414.54 642.56 486.81 370.67 420.66"/><path fill="#f6f6f6" d="m595.24,362.5l278.98,52.49-231.72,69.74-263.76-64.17,216.5-58.07m-.16-4.1l-232.49,62.36,280.02,68.12,248.47-74.78-296-55.7h0Z"/></g><polygon points="642.62 500.88 362.6 432.76 362.6 420.76 642.62 488.88 642.62 500.88"/><polygon points="891.09 426.1 642.62 500.88 642.62 488.88 891.09 414.1 891.09 426.1"/><rect x="635.12" y="488.88" width="15" height="230"/><rect x="362.6" y="420.76" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="530.59" y1="461.62" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="474.59" y1="448" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="418.59" y1="434.38" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="586.59" y1="475.25" x2="827.82" y2="404.16"/></svg>`,
      '5060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="348.11 415.17 570.17 355.61 907.66 419.17 664.89 492.24 348.11 415.17"/><path fill="#f6f6f6" d="m570.24,357.66l328.99,61.96-234.39,70.55-308.65-75.09,214.06-57.41m-.16-4.1l-230.05,61.7,324.91,79.04,251.14-75.59-346-65.16h0Z"/></g><polygon points="664.95 506.31 340.04 427.27 340.04 415.27 664.95 494.31 664.95 506.31"/><polygon points="916.09 430.73 664.95 506.31 664.95 494.31 916.09 418.73 916.09 430.73"/><rect x="657.45" y="494.31" width="15" height="230"/><rect x="494.99" y="456.61" width="15" height="211.39"/><rect x="340.04" y="415.27" width="15" height="200.17"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="502.49" y1="454.79" x2="738.42" y2="387.38"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="448.41" y1="441.63" x2="681.03" y2="376.45"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="394.25" y1="428.45" x2="623.34" y2="365.6"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="556.73" y1="467.98" x2="796.65" y2="398.07"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="610.89" y1="481.16" x2="853.91" y2="409.04"/></svg>`,
      '6060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="325.97 409.78 545.17 350.99 932.66 423.93 687.47 497.73 325.97 409.78"/><path fill="#f6f6f6" d="m545.24,353.04l378.99,71.34-236.82,71.28-353.37-85.97,211.2-56.65m-.16-4.1l-227.19,60.94,369.63,89.92,253.56-76.32-396-74.54h0Z"/></g><polygon points="687.52 511.8 317.9 421.88 317.9 409.88 687.52 499.8 687.52 511.8"/><polygon points="941.09 435.49 687.52 511.8 687.52 499.8 941.09 423.49 941.09 435.49"/><rect x="680.02" y="499.8" width="15" height="230"/><rect x="495.21" y="453.31" width="15" height="212.9"/><rect x="317.9" y="409.88" width="15" height="197.73"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="476.22" y1="448.4" x2="710.05" y2="382.23"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="423.51" y1="435.57" x2="653.64" y2="371.52"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="370.8" y1="422.75" x2="596.81" y2="360.92"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="528.93" y1="460.84" x2="766.89" y2="392.82"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="581.64" y1="474.04" x2="823.58" y2="403.46"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="634.35" y1="486.87" x2="880.09" y2="414.14"/></svg>`,
      '7060': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="325.97 409.78 545.17 350.99 932.66 423.93 687.47 497.73 325.97 409.78"/><path fill="#f6f6f6" d="m545.24,353.04l378.99,71.34-236.82,71.28-353.37-85.97,211.2-56.65m-.16-4.1l-227.19,60.94,369.63,89.92,253.56-76.32-396-74.54h0Z"/></g><polygon points="687.52 511.8 317.9 421.88 317.9 409.88 687.52 499.8 687.52 511.8"/><polygon points="941.09 435.49 687.52 511.8 687.52 499.8 941.09 423.49 941.09 435.49"/><rect x="680.02" y="499.8" width="15" height="230"/><rect x="495.21" y="453.31" width="15" height="212.9"/><rect x="317.9" y="409.88" width="15" height="197.73"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="476.22" y1="448.4" x2="710.05" y2="382.23"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="423.51" y1="435.57" x2="653.64" y2="371.52"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="370.8" y1="422.75" x2="596.81" y2="360.92"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="528.93" y1="460.84" x2="766.89" y2="392.82"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="581.64" y1="474.04" x2="823.58" y2="403.46"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="634.35" y1="486.87" x2="880.09" y2="414.14"/></svg>`,
    },
    polySpecs: {
      'Klar': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><line fill="none" stroke="#000" stroke-width="15" x1="704.17" y1="674.72" x2="607.52" y2="771.37"/><line fill="none" stroke="#000" stroke-width="15" x1="722.57" y1="730.67" x2="663.48" y2="789.76"/><line fill="none" stroke="#000" stroke-width="15" x1="372.05" y1="423.21" x2="468.71" y2="326.55"/><line fill="none" stroke="#000" stroke-width="15" x1="353.66" y1="367.25" x2="412.75" y2="308.16"/></svg>`,
      'Opal': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><g stroke="#000" stroke-width="5"><line x1="766.43" y1="210.83" x2="314.48" y2="869.39"/><line x1="766.57" y1="245.83" x2="340.7" y2="866.38"/><line x1="766.7" y1="280.83" x2="366.92" y2="863.37"/><line x1="766.83" y1="315.83" x2="393.13" y2="860.35"/><line x1="766.96" y1="350.83" x2="419.35" y2="857.34"/><line x1="767.09" y1="385.83" x2="445.57" y2="854.33"/><line x1="767.22" y1="420.83" x2="471.79" y2="851.32"/><line x1="767.35" y1="455.83" x2="498.01" y2="848.3"/><line x1="767.48" y1="490.84" x2="524.23" y2="845.29"/><line x1="767.61" y1="525.84" x2="550.45" y2="842.28"/><line x1="767.74" y1="560.84" x2="576.66" y2="839.27"/><line x1="767.87" y1="595.84" x2="602.88" y2="836.26"/><line x1="768.01" y1="630.84" x2="629.1" y2="833.24"/><line x1="768.14" y1="665.84" x2="655.32" y2="830.23"/><line x1="768.27" y1="700.84" x2="681.54" y2="827.22"/><line x1="768.4" y1="735.84" x2="707.76" y2="824.21"/><line x1="768.53" y1="770.85" x2="733.98" y2="821.19"/><line x1="314.48" y1="869.39" x2="766.43" y2="210.83"/><line x1="314.48" y1="834.39" x2="740.35" y2="213.84"/><line x1="314.48" y1="799.39" x2="714.26" y2="216.85"/><line x1="314.48" y1="764.39" x2="688.17" y2="219.86"/><line x1="314.48" y1="729.39" x2="662.08" y2="222.88"/><line x1="314.48" y1="694.39" x2="636" y2="225.89"/><line x1="314.48" y1="659.38" x2="609.91" y2="228.9"/><line x1="314.48" y1="624.38" x2="583.82" y2="231.91"/><line x1="314.48" y1="589.38" x2="557.73" y2="234.93"/><line x1="314.48" y1="554.38" x2="531.64" y2="237.94"/><line x1="314.48" y1="519.38" x2="505.56" y2="240.95"/><line x1="314.48" y1="484.38" x2="479.47" y2="243.96"/><line x1="314.48" y1="449.38" x2="453.38" y2="246.97"/><line x1="314.48" y1="414.37" x2="427.29" y2="249.99"/><line x1="314.48" y1="379.37" x2="401.21" y2="253"/><line x1="314.48" y1="344.37" x2="375.12" y2="256.01"/><line x1="314.48" y1="309.37" x2="349.03" y2="259.02"/></g></svg>`,
      'Solar Control': `<svg viewBox="0 0 1080 1080"><polyline fill="none" stroke="#000" stroke-width="15" points="607.53 206.24 790 182.57 790 832.57 290 897.43 290 247.43"/><g><circle fill="none" stroke="#000" stroke-width="15" cx="464.64" cy="267.56" r="61.04"/><line fill="none" stroke="#000" stroke-width="15" x1="464.64" y1="355.61" x2="464.64" y2="391.61"/><line fill="none" stroke="#000" stroke-width="15" x1="464.64" y1="143.51" x2="464.64" y2="179.51"/><line fill="none" stroke="#000" stroke-width="15" x1="376.59" y1="267.56" x2="340.59" y2="267.56"/><line fill="none" stroke="#000" stroke-width="15" x1="588.69" y1="267.56" x2="552.69" y2="267.56"/><line fill="none" stroke="#000" stroke-width="15" x1="402.38" y1="329.82" x2="376.92" y2="355.28"/><line fill="none" stroke="#000" stroke-width="15" x1="552.36" y1="179.84" x2="526.9" y2="205.3"/><line fill="none" stroke="#000" stroke-width="15" x1="402.38" y1="205.3" x2="376.92" y2="179.84"/><line fill="none" stroke="#000" stroke-width="15" x1="552.36" y1="355.28" x2="526.9" y2="329.82"/></g><g stroke="#000" stroke-width="5"><line x1="768.53" y1="210.83" x2="316.57" y2="869.39"/><line x1="768.53" y1="245.83" x2="342.66" y2="866.38"/><line x1="768.53" y1="280.83" x2="368.75" y2="863.37"/><line x1="768.53" y1="315.83" x2="394.84" y2="860.35"/><line x1="768.53" y1="350.83" x2="420.92" y2="857.34"/><line x1="768.53" y1="385.83" x2="447.01" y2="854.33"/><line x1="768.53" y1="420.83" x2="473.1" y2="851.32"/><line x1="768.53" y1="455.83" x2="499.19" y2="848.3"/><line x1="768.53" y1="490.84" x2="525.27" y2="845.29"/><line x1="768.53" y1="525.84" x2="551.36" y2="842.28"/><line x1="768.53" y1="560.84" x2="577.45" y2="839.27"/><line x1="768.53" y1="595.84" x2="603.54" y2="836.26"/><line x1="768.53" y1="630.84" x2="629.63" y2="833.24"/><line x1="768.53" y1="665.84" x2="655.71" y2="830.23"/><line x1="768.53" y1="700.84" x2="681.8" y2="827.22"/><line x1="768.53" y1="735.84" x2="707.89" y2="824.21"/><line x1="768.53" y1="770.85" x2="733.98" y2="821.19"/><line x1="316.57" y1="869.39" x2="768.53" y2="210.83"/><line x1="316.44" y1="834.39" x2="742.31" y2="213.84"/><line x1="316.31" y1="799.39" x2="716.09" y2="216.85"/><line x1="316.18" y1="764.39" x2="689.87" y2="219.86"/><line x1="316.05" y1="729.39" x2="663.65" y2="222.88"/><line x1="315.92" y1="694.39" x2="504.52" y2="418.61"/><line x1="315.79" y1="659.38" x2="478.3" y2="421.63"/><line x1="315.66" y1="624.38" x2="452.08" y2="424.64"/><line x1="315.53" y1="589.38" x2="425.87" y2="427.65"/><line x1="315.39" y1="554.38" x2="399.65" y2="430.66"/><line x1="315.26" y1="519.38" x2="394.43" y2="400.48"/><line x1="315.13" y1="484.38" x2="368.22" y2="403.49"/></g></svg>`,
      'Ultra-klar': `<svg viewBox="0 0 1080 1080"><polygon fill="none" stroke="#000" stroke-width="15" points="790 832.57 290 897.43 290 247.43 790 182.57 790 832.57"/><line fill="none" stroke="#000" stroke-width="15" x1="704.17" y1="674.72" x2="607.52" y2="771.37"/><line fill="none" stroke="#000" stroke-width="15" x1="722.57" y1="730.67" x2="663.48" y2="789.76"/><line fill="none" stroke="#000" stroke-width="15" x1="372.05" y1="423.21" x2="468.71" y2="326.55"/><line fill="none" stroke="#000" stroke-width="15" x1="353.66" y1="367.25" x2="412.75" y2="308.16"/><path fill="none" stroke="#000" stroke-width="5" d="m712.1,369.7c-38.4,7.88-43.67,14.27-50.17,60.86-6.5-46.58-11.77-52.97-50.17-60.86,38.4-7.88,43.67-14.27,50.17-60.86,6.5,46.58,11.77,52.97,50.17,60.86Z"/><path fill="none" stroke="#000" stroke-width="5" d="m541.88,626.78c-38.4,7.88-43.67,14.27-50.17,60.86-6.5-46.58-11.77-52.97-50.17-60.86,38.4-7.88,43.67-14.27,50.17-60.86,6.5,46.58,11.77,52.97,50.17,60.86Z"/></svg>`
    },
    addons: {
      'rund': `<svg viewBox="${zoomStandard}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m340,260h285.82c5.15,4.26,114.18,98.11,114.18,280,0,8.37-2.28,187.49-114.18,280h-285.82"/></svg>`,
      'klassisch': `<svg viewBox="${zoomStandard}"><polyline fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" points="342.37 257.63 742.37 257.63 742.37 349.96 652.37 495.52 652.37 578.87 561.61 723.26 561.61 817.63 342.37 817.63"/></svg>`,
      'beton': `<svg viewBox="${zoomBox}"><rect x="15" y="25" width="70" height="40" fill="#e0e0e0" stroke="#888" stroke-width="3"/><path d="M15 25 L 30 10 L 100 10 L 85 25" fill="#f0f0f0" stroke="#888" stroke-width="3"/><path d="M85 25 L 85 65 L 100 50 L 100 10" fill="#ccc" stroke="#888" stroke-width="3"/></svg>`,
      'beton_abfluss': `<svg viewBox="${zoomBox}"><rect x="15" y="25" width="70" height="40" fill="#e0e0e0" stroke="#888" stroke-width="3"/><path d="M15 25 L 30 10 L 100 10 L 85 25" fill="#f0f0f0" stroke="#888" stroke-width="3"/><circle cx="50" cy="45" r="10" fill="#333" stroke="#888" stroke-width="2"/></svg>`,
      'bohrer': `<svg viewBox="${zoomBox}"><rect x="20" y="30" width="60" height="15" fill="#aaa" stroke="#666" stroke-width="2"/><path d="M80 30 L 95 37.5 L 80 45" fill="#666"/><rect x="5" y="25" width="15" height="25" fill="#444"/></svg>`,
      'heizung': `<svg viewBox="${zoomBox}"><rect x="10" y="20" width="80" height="20" rx="5" fill="#333"/><path d="M15 50 Q 25 40, 35 50 T 55 50 T 75 50 T 95 50" stroke="orange" stroke-width="3" fill="none"/><path d="M15 60 Q 25 50, 35 60 T 55 60 T 75 60 T 95 60" stroke="orange" stroke-width="3" fill="none"/></svg>`,
      'montage': `<svg viewBox="${zoomBox}"><rect x="20" y="20" width="60" height="40" fill="#d2b48c" stroke="#8b4513" stroke-width="2"/><path d="M20 20 L 50 40 L 80 20" stroke="#8b4513" stroke-width="2"/><path d="M50 20 L 50 60" stroke="#8b4513" stroke-width="2"/></svg>`,
      'stift': `<svg viewBox="${zoomBox}"><rect x="30" y="20" width="40" height="40" fill="#333" stroke="#000"/><path d="M30 60 L 50 75 L 70 60" fill="#555"/><rect x="30" y="5" width="40" height="15" fill="#888"/></svg>`,
      'profil': `<svg viewBox="${zoomBox}"><rect x="30" y="10" width="20" height="60" fill="#ccc" stroke="#666" stroke-width="2"/><rect x="50" y="50" width="30" height="20" fill="#ccc" stroke="#666" stroke-width="2"/></svg>`,
      'led': `<svg viewBox="${zoomDetail}"><rect fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x="350" y="718.89" width="357.83" height="101.11" rx=".9" ry=".9"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m529.17,376.5h10.69c59.87,0,108.47,48.6,108.47,108.47v234.59h-227.63v-234.59c0-59.87,48.6-108.47,108.47-108.47Z"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m540,425.03c-5.09-.01-31.13.44-52.39,21.49-20.74,20.53-22.1,45.97-22.27,51.29"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m532.41,583.47h4.22c23.63,0,42.82,19.19,42.82,42.82v92.6h-89.86v-92.6c0-23.63,19.19-42.82,42.82-42.82Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="540" y1="260" x2="540" y2="339.13"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="740" y1="331.9" x2="679.93" y2="382.77"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="340" y1="331.9" x2="400.07" y2="382.77"/></svg>`,
      'keilfenster': `<svg viewBox="${zoomVertical}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m830,473.86H250v-212.55c0-.8.55-1.41,1.16-1.29l578,118.86c.49.1.84.65.84,1.29v93.69Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="473.86" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="473.86" x2="250" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="336.94" y1="321.65" x2="281.89" y2="355.61"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="375.67" y1="335.45" x2="320.62" y2="369.4"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="723.12" y1="397.27" x2="668.07" y2="431.22"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="761.85" y1="411.06" x2="706.8" y2="445.02"/><path d="m830,473.86H250v-212.55c0-.8.55-1.41,1.16-1.29l578,118.86c.49.1.84.65.84,1.29v93.69Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="473.86" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="473.86" x2="250" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="336.94" y1="321.65" x2="281.89" y2="355.61"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="375.67" y1="335.45" x2="320.62" y2="369.4"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="723.12" y1="397.27" x2="668.07" y2="431.22"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="761.85" y1="411.06" x2="706.8" y2="445.02"/></svg>`,
      'seitenwand': `<svg viewBox="${zoomVertical}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m830,435.4H250v-174.33c0-.66.55-1.16,1.16-1.06l578,97.49c.49.08.84.53.84,1.06v76.84Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="435.4" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="435.4" x2="250" y2="820"/><path d="m670.43,447.81v347.19h-407.92v-347.19h407.92m25-25H237.51v397.19h457.92v-397.19h0Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="355.5" y1="487.97" x2="300.45" y2="521.92"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="394.23" y1="501.76" x2="339.18" y2="535.71"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="355.5" y1="487.97" x2="300.45" y2="521.92"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="588.32" y1="709.01" x2="533.27" y2="742.97"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="627.06" y1="722.81" x2="572" y2="756.76"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="588.32" y1="709.01" x2="533.27" y2="742.97"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="627.06" y1="722.81" x2="572" y2="756.76"/></svg>`,
      'schlagduebel': `<svg viewBox="400 200 280 680"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m462.5,260h220v6.9c0,26.92-21.85,48.77-48.77,48.77h-122.46c-26.92,0-48.77-21.85-48.77-48.77v-6.9h0Z"/><rect fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x="540" y="317.31" width="65" height="222.69"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="360.7" x2="605" y2="404.39"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="406.81" x2="605" y2="450.5"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="452.92" x2="605" y2="496.61"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m587.32,820h-29.73c-2.86,0-5.26-2.01-5.55-4.66l-28.68-265.77c-.46-4.25,3.14-7.94,7.74-7.94h82.8c4.6,0,8.2,3.69,7.74,7.94l-28.78,265.77c-.29,2.64-2.68,4.65-5.55,4.65Z"/></svg>`,
      'poly': `<svg viewBox="0 0 1080 1080"><path fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" d="m789.2,412.62h-498.4c-.47,0-.87.32-.98.78l-49.55,219.14c-.14.63.33,1.22.98,1.22h597.5c.64,0,1.12-.6.98-1.22l-49.55-219.14c-.1-.46-.51-.78-.98-.78Z"/><polyline fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" points="840 633.76 840 692.54 240 692.54 240 633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="540" y1="412.62" x2="540" y2="633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="621.53" y1="413.45" x2="648.47" y2="632.93"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="458.47" y1="413.45" x2="431.53" y2="632.93"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="705.8" y1="414.3" x2="744.2" y2="632.08"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="539.46" y1="633.21" x2="539.46" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="646.91" y1="633.21" x2="646.91" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="743.96" y1="633.21" x2="743.96" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="337" y1="633.21" x2="337" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="434.04" y1="633.21" x2="434.04" y2="691.99"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="374.2" y1="414.3" x2="335.8" y2="632.08"/></svg>`,
      'glas': `<svg viewBox="0 0 1080 1080"><path fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" d="m789.2,412.62h-498.4c-.47,0-.87.32-.98.78l-49.55,219.14c-.14.63.33,1.22.98,1.22h597.5c.64,0,1.12-.6.98-1.22l-49.55-219.14c-.1-.46-.51-.78-.98-.78Z"/><polyline fill="none" stroke="#000" stroke-width="25px" stroke-miterlimit="10" points="840 633.76 840 692.54 240 692.54 240 633.76"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="727.18" y1="540" x2="672.13" y2="573.96"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="765.92" y1="553.79" x2="710.87" y2="587.75"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="386.82" y1="451.78" x2="331.77" y2="485.73"/><line fill="none" stroke="#000" stroke-width="10px" stroke-miterlimit="10" x1="425.56" y1="465.57" x2="370.51" y2="499.52"/></svg>`
    },
    colors: {
      'RAL9001': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#F2EAD6" stroke="#ddd" stroke-width="2"/></svg>`, 
      'RAL7016M': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#373F43"/></svg>`, 
      'RAL9016': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#FFFFFF" stroke="#E5E7EB" stroke-width="3"/></svg>`, 
      'RAL9005': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#1C1C1C"/></svg>` 
    }
  };
  const fallbackSVG = `<svg viewBox="0 0 100 75"><rect width="100" height="75" fill="#f5f5f5"/><text x="50" y="50" font-size="20" text-anchor="middle" dominant-baseline="middle" fill="#ccc">?</text></svg>`;
  // --- END SVG ICONS ---


  const varInput = document.getElementById('giallo-variant-id');
  const form = document.getElementById('giallo-product-form');
  
  const getAllButtons = () => {
    if(!form) return [];
    const btnsInside = Array.from(form.querySelectorAll('button[type="submit"]'));
    const btnsOutside = Array.from(document.querySelectorAll('button[type="submit"][form="giallo-product-form"]'));
    return [...btnsInside, ...btnsOutside];
  };

  const titW = document.getElementById('tit-width');
  const titD = document.getElementById('tit-depth');
  const titR = document.getElementById('tit-roof');
  const titC = document.getElementById('tit-color');
  const titA = document.getElementById('tit-addons');
  const colorInput = document.getElementById('prop-color');
  const noteRAL = document.getElementById('note-ral9001');
  const ralCard = document.getElementById('swatch-ral9001');
  const pcWrap = document.getElementById('poly-subtype-wrap');
  const warnGlass = document.getElementById('warn-glass-span');
  const warnBeam  = document.getElementById('warn-beam');
  const reinfChk  = document.getElementById('prop-reinf');
  const accItems = [...document.querySelectorAll('.g-acc__item')];
  
  const sumPriceLine = document.getElementById('sum-price-line');
  const sumAddonsPrice = document.getElementById('sum-addons-price');
  const sumPriceFinal = document.getElementById('sum-price-final');
  
  const sumDimensionsWrap = document.getElementById('sum-dimensions-wrap');
  const sumWidth = document.getElementById('sum-width');
  const sumDepth = document.getElementById('sum-depth');
  const sumColorWrap = document.getElementById('sum-color-wrap');
  const sumColor = document.getElementById('sum-color');
  const sumRoofWrap = document.getElementById('sum-roof-wrap');
  const sumRoof = document.getElementById('sum-roof');
  const sumPcSpec = document.getElementById('sum-pc-spec');
  const sumAddonsWrap = document.getElementById('sum-addons-wrap');
  const sumAddonsList = document.getElementById('sum-addons-list');
  const validationMessage = document.getElementById('giallo-validation-message');

  const footerSummaryText = document.getElementById('footer-summary-text');
  const footerPriceFinal = document.getElementById('footer-price-final');
  
  const addonPriceCache = {};
  
  const fetchProductPrice = async (handle) => {
    if (addonPriceCache[handle]) return addonPriceCache[handle];
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return 0;
      const product = await response.json();
      const price = product.variants[0].price;
      addonPriceCache[handle] = price;
      return price;
    } catch (e) { return 0; }
  };

  // NEW: Updates the visible price tag on all addon cards
  const updateUIAddonPrices = async () => {
    const targets = form.querySelectorAll('[data-handle]'); 
    for(const t of targets){
       const handle = t.dataset.handle;
       const price = await fetchProductPrice(handle);
       const card = t.closest('.g-card');
       const priceEl = card ? card.querySelector('.g-card__price') : null;
       if(priceEl) priceEl.textContent = fmt(price);
    }
  };
  
  function generateChoiceCards(containerId, inputName, options, type) {
    const container = document.getElementById(containerId);
    if (!container) return;
    
    container.innerHTML = options.map(opt => {
      const iconSvg = (svgIcons[type] && svgIcons[type][opt]) ? svgIcons[type][opt] : fallbackSVG;
      return `
        <label class="g-card">
          <input type="radio" name="${inputName}" value="${opt}" class="visually-hidden">
          <div class="g-card__thumb">${iconSvg}</div>
          <div class="g-card__label">${opt} mm</div>
        </label>
      `;
    }).join('');
  }
  const unique = arr => [...new Set(arr)];
  const widths = unique(variants.map(v => v.option1)).sort();
  const depths = unique(variants.map(v => v.option2)).sort((a,b)=>parseInt(a)-parseInt(b));

  generateChoiceCards('width-options-grid', 'opt-width', widths, 'width');
  generateChoiceCards('depth-options-grid', 'opt-depth', depths, 'depth');

  function updateStaticIcon(selector, iconKey, type) {
    if(selector) {
      const el = form.querySelector(selector);
      if(el) {
        const card = el.classList.contains('g-card') ? el : el.closest('.g-card');
        const thumb = card?.querySelector('.g-card__thumb');
        if(thumb && svgIcons[type] && svgIcons[type][iconKey]) {
          thumb.innerHTML = svgIcons[type][iconKey];
        }
      }
    }
  }
  
  const iconCards = form.querySelectorAll('.g-card__thumb[data-icon]');
  iconCards.forEach(thumb => {
      const iconKey = thumb.dataset.icon;
      if(svgIcons.addons[iconKey]) {
          thumb.innerHTML = svgIcons.addons[iconKey];
      }
  });


  updateStaticIcon('input[value="rund"]', 'rund', 'addons');
  updateStaticIcon('input[value="klassisch"]', 'klassisch', 'addons');
  updateStaticIcon('button[data-color="RAL9001"]', 'RAL9001', 'colors');
  updateStaticIcon('button[data-color="RAL7016M"]', 'RAL7016M', 'colors');
  updateStaticIcon('button[data-color="RAL9016"]', 'RAL9016', 'colors');
  updateStaticIcon('button[data-color="RAL9005"]', 'RAL9005', 'colors');

  updateStaticIcon('input[value="Klar"]', 'Klar', 'polySpecs');
  updateStaticIcon('input[value="Opal"]', 'Opal', 'polySpecs');
  updateStaticIcon('input[value="Solar Control"]', 'Solar Control', 'polySpecs');
  updateStaticIcon('input[value="Ultra-klar"]', 'Ultra-klar', 'polySpecs');

  updateStaticIcon('input[value="Polycarbonat"]', 'poly', 'addons');
  updateStaticIcon('input[value="Glas"]', 'glas', 'addons');
  
  // MAIN ACCORDION LOGIC
  accItems.forEach((item) => {
    const summary = item.querySelector('.g-acc__summary');
    const content = item.querySelector('.g-acc__body');
    
    // Initial State
    if (item.hasAttribute('open')) { 
       content.style.maxHeight = 'none'; // Allow dynamic height for pre-opened items
    } else { 
       content.style.maxHeight = '0px'; 
    }
    
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (item.hasAttribute('open')) {
        // Closing
        content.style.maxHeight = content.scrollHeight + 'px'; // Set pixel height first for transition
        setTimeout(() => { content.style.maxHeight = '0px'; }, 10);
        setTimeout(() => { item.removeAttribute('open'); }, 500); // Wait for transition
      } else {
        // Opening
        item.setAttribute('open', '');
        content.style.maxHeight = content.scrollHeight + 'px';
        // After transition, remove max-height constraint to allow inner accordions to expand
        setTimeout(() => { 
            if(item.hasAttribute('open')) content.style.maxHeight = 'none'; 
        }, 500);
      }
    });
  });

  // SUB ACCORDION LOGIC
  const subItems = document.querySelectorAll('.g-acc__sub');
  subItems.forEach((item) => {
    const summary = item.querySelector('.g-acc__sub-summary');
    const content = item.querySelector('.g-acc__sub-body');

    if (!item.hasAttribute('open')) { content.style.maxHeight = '0px'; }

    summary.addEventListener('click', (e) => {
        e.preventDefault();
        const parentBody = item.closest('.g-acc__body'); // The parent container

        if (item.hasAttribute('open')) {
            // Closing sub-item
            content.style.maxHeight = content.scrollHeight + 'px';
            setTimeout(() => { content.style.maxHeight = '0px'; }, 10);
            setTimeout(() => { item.removeAttribute('open'); }, 300);
        } else {
            // Opening sub-item
            item.setAttribute('open', '');
            content.style.maxHeight = content.scrollHeight + 'px';
            setTimeout(() => { 
                if(item.hasAttribute('open')) content.style.maxHeight = 'none'; 
            }, 300);
        }
    });
  });

  const closeCurrentStep = (el) => {
    const currentItem = el.closest('.g-acc__item');
    if (currentItem && currentItem.hasAttribute('open')) { 
        // We trigger click to close, so it animates
        currentItem.querySelector('.g-acc__summary').click(); 
    }
  };
  
  const flashElement = (el) => {
    el.classList.add('flash-animation');
    setTimeout(() => { el.classList.remove('flash-animation'); }, 700);
  };

  const getSelectedValue = name => form.querySelector(`input[name="${name}"]:checked`)?.value || '';
  const fmt = (c) => (typeof Shopify!=='undefined'&&Shopify.formatMoney)? Shopify.formatMoney(c):(c/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'});

  function setColor(val, labelText){
    const colorCards = form.querySelectorAll('#color-swatches .g-card');
    colorInput.value = val || '';
    colorCards.forEach(c => {
      const active = c.dataset.color === val;
      c.setAttribute('aria-pressed', String(active));
      c.setAttribute('aria-checked', String(active));
    });
    const newColorText = labelText || (val || '–');
    if (titC.textContent !== newColorText) {
      titC.textContent = newColorText;
      flashElement(titC);
    }
    validateAndRender();
  }
  
  async function validateAndRender(){
    const w = getSelectedValue('opt-width');
    const d = getSelectedValue('opt-depth');
    const r = getSelectedValue('opt-roof');
    let pcSubtype = getSelectedValue('properties[pc_subtype]');

    if (r === 'Polycarbonat') {
      const subtypes = ['Klar', 'Opal', 'Ultra-klar', 'Solar Control'];
      subtypes.forEach(subtype => {
        const input = form.querySelector(`input[name="properties[pc_subtype]"][value="${subtype}"]`);
        if (input) {
          const variantExists = variants.some(v => v.option1 == w && v.option2 == d && v.option3 === `Polycarbonat ${subtype}`);
          const card = input.closest('.g-card');
          if (card) {
            card.classList.toggle('option-disabled', !variantExists);
            if (!variantExists && input.checked) {
              input.checked = false;
              pcSubtype = '';
            }
          }
        }
      });
      if (!pcSubtype) {
        const klarInput = form.querySelector('input[name="properties[pc_subtype]"][value="Klar"]');
        if (klarInput && !klarInput.closest('.g-card').classList.contains('option-disabled')) {
          klarInput.checked = true;
          pcSubtype = 'Klar';
        } else {
           const opalInput = form.querySelector('input[name="properties[pc_subtype]"][value="Opal"]');
           if (opalInput && !opalInput.closest('.g-card').classList.contains('option-disabled')) {
               opalInput.checked = true;
               pcSubtype = 'Opal';
           }
        }
      }
    }

    let variantOption3 = r;
    if (r === 'Polycarbonat') {
        variantOption3 = `Polycarbonat ${pcSubtype}`;
    }

    const variant = (w && d && variantOption3) ? 
        variants.find(v => v.option1 == w && v.option2 == d && v.option3 == variantOption3) 
        : null;
    
    const newWidthText = w ? `${w} mm` : '–';
    if (titW.textContent !== newWidthText) { titW.textContent = newWidthText; flashElement(titW); }
    const newDepthText = d ? `${d} mm` : '–';
    if (titD.textContent !== newDepthText) { titD.textContent = newDepthText; flashElement(titD); }
    const newRoofText = r || '–';
    if (titR.textContent !== newRoofText) { titR.textContent = newRoofText; flashElement(titR); }

    sumDimensionsWrap.classList.toggle('hidden', !w || !d);
    sumWidth.textContent = w;
    sumDepth.textContent = d;
    sumColorWrap.classList.toggle('hidden', !colorInput.value);
    sumColor.textContent = colorInput.value;
    sumRoofWrap.classList.toggle('hidden', !r);
    sumRoof.textContent = r;
    sumPcSpec.classList.toggle('hidden', r !== 'Polycarbonat');

    const zier = getSelectedValue('addon-zierleiste');
    const qtyInputs = form.querySelectorAll('.addon-qty');
    let hasQtyAddons = false;
    let addonTextList = [];
    if(zier) addonTextList.push(zier);

    qtyInputs.forEach(input => {
        if(parseInt(input.value) > 0) {
            hasQtyAddons = true;
            const card = input.closest('.g-card');
            const label = card.querySelector('.g-card__label').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            addonTextList.push(`${input.value}x ${label}`);
        }
    });

    sumAddonsWrap.classList.toggle('hidden', addonTextList.length === 0);
    sumAddonsList.textContent = addonTextList.join(', ');

    if (w === '7060') {
      noteRAL.classList.remove('hidden'); ralCard?.classList.add('option-disabled'); ralCard?.setAttribute('aria-disabled','true'); ralCard?.setAttribute('tabindex','-1');
      if (colorInput.value === 'RAL9001') setColor('', '');
    } else {
      noteRAL.classList.add('hidden'); ralCard?.classList.remove('option-disabled'); ralCard?.removeAttribute('aria-disabled'); ralCard?.removeAttribute('tabindex');
    }
    
    const isPoly = r === 'Polycarbonat';
    const wasHiddenPoly = pcWrap.classList.contains('hidden');
    pcWrap.classList.toggle('hidden', !isPoly);
    
    // Parent height recalculation for poly wrapper
    if ((isPoly && wasHiddenPoly) || (!isPoly && !wasHiddenPoly)) {
      setTimeout(() => {
        const detailsItem = pcWrap.closest('.g-acc__item');
        if (detailsItem && detailsItem.hasAttribute('open')) {
           // Since we use max-height: none for open items now, this might not be strictly needed,
           // but good for safety during transitions.
        }
      }, 10);
    }
    
    if (variant && r === 'Glas') {
      const span = variant.metafields.max_post_span_mm.value || 0;
      warnGlass.textContent = span ? `Hinweis: Bei Glas beträgt der maximale Pfostenabstand ${span} mm.` : '';
      warnGlass.classList.toggle('hidden', !span);
    } else { warnGlass.classList.add('hidden'); }

    const is6000 = d === '6000';
    const wasHiddenBeam = warnBeam.classList.contains('hidden');
    warnBeam.classList.toggle('hidden', !is6000);
    if (!is6000 && reinfChk) reinfChk.checked = false;
    
    let basePrice = 0;
    if (variant && variant.available) {
      varInput.value = variant.id;
      basePrice = variant.price;
    } else {
      varInput.value = '';
    }

    let addonTotal = 0;
    
    if(zier) {
        const r = form.querySelector('input[name="addon-zierleiste"]:checked');
        const price = await fetchProductPrice(r.dataset.handle);
        addonTotal += price; 
    }

    for (const input of qtyInputs) {
      const qty = parseInt(input.value);
      if (qty > 0) {
        const card = input.closest('.g-card');
        const price = await fetchProductPrice(card.dataset.handle);
        addonTotal += (price * qty);
      }
    }

    const finalPrice = basePrice + addonTotal;
    sumPriceLine.textContent = fmt(basePrice);
    sumAddonsPrice.textContent = fmt(addonTotal);
    sumPriceFinal.textContent = fmt(finalPrice);
    footerPriceFinal.textContent = fmt(finalPrice);
    
    const summaryItems = [w ? `${w}x${d}mm` : null, colorInput.value, r, zier, hasQtyAddons ? `Zubehör` : null].filter(Boolean);
    footerSummaryText.textContent = summaryItems.join(' / ');

    let totalAddonCount = 0;
    qtyInputs.forEach(i => totalAddonCount += parseInt(i.value));
    if (zier) { totalAddonCount += 1; }
    const newAddonText = totalAddonCount > 0 ? `${totalAddonCount} Artikel` : '–';
    if (titA.textContent !== newAddonText) {
      titA.textContent = newAddonText;
      flashElement(titA);
    }
    
    const missingSelections = [];
    if (!w) missingSelections.push('Breite');
    if (!d) missingSelections.push('Ausfall');
    if (!r) missingSelections.push('Dacheindeckung');
    if (!colorInput.value) missingSelections.push('Farbe');
    
    if (r === 'Polycarbonat' && !pcSubtype) missingSelections.push('Polycarbonat-Ausführung');
    if (d === '6000' && !reinfChk.checked) missingSelections.push('Bestätigung (6000mm)');

    const allButtons = getAllButtons();
    if (missingSelections.length > 0) {
      validationMessage.textContent = `Bitte wählen Sie noch: ${missingSelections.join(', ')}`;
      validationMessage.classList.remove('hidden');
      allButtons.forEach(btn => btn.disabled = true);
    } else {
      validationMessage.classList.add('hidden');
      const shouldDisable = !varInput.value;
      allButtons.forEach(btn => btn.disabled = shouldDisable);
    }
  }

  const resetConfigurator = () => {
    form.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => input.checked = false);
    form.querySelectorAll('.addon-qty').forEach(i => i.value = 0);
    form.querySelectorAll('.g-card').forEach(c => c.classList.remove('has-qty'));
    // Close Sub-Accordions
    subItems.forEach(item => {
        if(item.hasAttribute('open')) {
            item.removeAttribute('open');
            item.querySelector('.g-acc__sub-body').style.maxHeight = '0px';
        }
    });

    setColor('', '');
    validateAndRender();
    accItems.forEach(item => {
      if (!item.hasAttribute('open')) { item.querySelector('.g-acc__summary').click(); }
    });
    document.querySelector('.g-acc__item[data-step="1"]')?.scrollIntoView({ behavior: 'smooth' });
  };

  form.querySelector('#color-swatches').addEventListener('click', (e) => {
    const card = e.target.closest('.g-card');
    if (card) { setColor(card.dataset.color, card.dataset.label); closeCurrentStep(card); }
  });
  
  form.addEventListener('change', (e) => {
    const target = e.target;
    if (target.matches('input[type="radio"]')) {
      const isPolyRadio = target.name === 'opt-roof' && target.value === 'Polycarbonat';
      const is6000mmRadio = target.name === 'opt-depth' && target.value === '6000';
      const inAddons = target.closest('#giallo-addons');
      if (!isPolyRadio && !inAddons && !is6000mmRadio) {
        if(target.name !== 'properties[pc_subtype]') {
             closeCurrentStep(target);
        }
      }
    }
    validateAndRender();
  });

  form.addEventListener('click', (e) => {
    if (e.target.matches('.g-qty-btn')) {
        const btn = e.target;
        const wrapper = btn.closest('.g-qty-wrapper');
        const input = wrapper.querySelector('input');
        const card = btn.closest('.g-card');
        let val = parseInt(input.value) || 0;

        if (btn.classList.contains('plus')) {
            val++;
        } else if (btn.classList.contains('minus')) {
            if (val > 0) val--;
        }
        
        input.value = val;
        
        if (val > 0) {
            card.classList.add('has-qty');
        } else {
            card.classList.remove('has-qty');
        }
        
        validateAndRender();
    }
  });


  document.getElementById('addon-zierleiste-clear')?.addEventListener('click', () => {
    const r = form.querySelector('input[name="addon-zierleiste"]:checked');
    if (r) r.checked = false;
    validateAndRender();
  });

  document.getElementById('giallo-reset-btn')?.addEventListener('click', resetConfigurator);
  
  const handleAddClick = (e) => {
    const btn = e.currentTarget;
    if (btn && btn.disabled) {
      e.preventDefault();
      const validationMessage = document.getElementById('giallo-validation-message');
      if (validationMessage && !validationMessage.classList.contains('hidden')) {
        validationMessage.classList.add('shake-animation');
        setTimeout(() => { validationMessage.classList.remove('shake-animation'); }, 600);
      }
    }
  };
  
  getAllButtons().forEach(btn => {
    btn.addEventListener('click', handleAddClick);
  });

  // Call the new UI updater here
  updateUIAddonPrices();
  validateAndRender();

  async function getFirstVariantIdByHandle(handle){
    try{
      const res = await fetch(`/products/${handle}.js`); if(!res.ok) return null;
      const p = await res.json(); return p?.variants?.[0]?.id || null;
    }catch(e){ return null; }
  }

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const allButtons = getAllButtons();
    if (allButtons.some(btn => btn.disabled)) return;
    
    allButtons.forEach(btn => btn.disabled = true);
    
    try {
      const mainVariantId = varInput.value;
      if(!mainVariantId) return;
      const configurationId = Date.now();
      const formData = new FormData(form);
      const properties = {};
      for (const [k, v] of formData.entries()) {
        if (k.startsWith('properties[')) properties[k.slice(11,-1)] = v;
      }
      properties['_config_id'] = configurationId;
      
      const addItems = [{ id: Number(mainVariantId), quantity: 1, properties }];
      
      const zier = form.querySelector('input[name="addon-zierleiste"]:checked');
      if (zier) {
        const vid = await getFirstVariantIdByHandle(zier.dataset.handle);
        if (vid) addItems.push({ id: Number(vid), quantity: 1, properties: { _parent: String(mainVariantId), _lock_qty: '1', _config_id: configurationId } });
      }

      const qtyInputs = form.querySelectorAll('.addon-qty');
      for (const input of qtyInputs) {
          const qty = parseInt(input.value);
          if (qty > 0) {
              const card = input.closest('.g-card');
              const vid = await getFirstVariantIdByHandle(card.dataset.handle);
              if (vid) {
                  addItems.push({ 
                      id: Number(vid), 
                      quantity: qty, 
                      properties: { _parent: String(mainVariantId), _config_id: configurationId } 
                  });
              }
          }
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ items: addItems })
      });
      if(res.ok){
        window.location.href = '/cart';
      } else {
        const err = await res.json().catch(()=>({}));
        alert(err?.message || 'Fehler: Artikel konnte nicht in den Warenkorb gelegt werden.');
      }
    } catch(err) {
      alert('Ein Netzwerkfehler ist aufgetreten.');
    } finally {
      allButtons.forEach(btn => btn.disabled = false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kubus"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dataEl = document.getElementById('giallo-variant-data');
  if (!dataEl) return;

  const data = JSON.parse(dataEl.textContent);
  const variants = data.variants;

  const zoomStandard = "0 220 1080 680";
  const zoomVertical = "200 100 680 880";
  const zoomDetail = "300 250 480 600";
  const zoomBox = "0 0 100 75";

  const svgIcons = {
    depth: {
      '2500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="399.67 412.22 595.16 360.45 882.67 414.55 671.51 478.35 399.67 412.22"/><path fill="#f6f6f6" d="m595.24,362.5l279.03,52.5-202.81,61.28-263.66-64.14,187.44-49.64m-.15-4.1l-203.54,53.9,280.02,68.12,219.52-66.33-296-55.7h0Z"/></g><polygon points="671.57 492.41 391.55 424.29 391.55 412.29 671.57 480.41 671.57 492.41"/><polygon points="891.09 426.1 671.57 492.42 671.57 480.42 891.09 414.1 891.09 426.1"/><rect x="664.07" y="480.41" width="15" height="230"/><rect x="391.55" y="412.29" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="559.76" y1="453.21" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="504.11" y1="439.68" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="448.49" y1="426.15" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="615.42" y1="466.75" x2="827.82" y2="404.16"/></svg>`,
      '3000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="370.67 420.66 595.16 360.45 882.66 414.54 642.56 486.81 370.67 420.66"/><path fill="#f6f6f6" d="m595.24,362.5l278.98,52.49-231.72,69.74-263.76-64.17,216.5-58.07m-.16-4.1l-232.49,62.36,280.02,68.12,248.47-74.78-296-55.7h0Z"/></g><polygon points="642.62 500.88 362.6 432.76 362.6 420.76 642.62 488.88 642.62 500.88"/><polygon points="891.09 426.1 642.62 500.88 642.62 488.88 891.09 414.1 891.09 426.1"/><rect x="635.12" y="488.88" width="15" height="230"/><rect x="362.6" y="420.76" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="530.59" y1="461.62" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="474.59" y1="448" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="418.59" y1="434.38" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="586.59" y1="475.25" x2="827.82" y2="404.16"/></svg>`,
      '3500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="339.57 429.87 595.17 360.45 882.65 414.54 611.51 496.02 339.57 429.87"/><path fill="#f6f6f6" d="m595.25,362.5l278.96,52.49-262.76,78.96-263.86-64.19,247.65-67.26m-.16-4.1l-263.54,71.57,280.02,68.12,279.52-84-296-55.7h0Z"/></g><polygon points="611.57 510.09 331.55 441.97 331.55 429.97 611.57 498.09 611.57 510.09"/><polygon points="891.09 426.1 611.57 510.09 611.57 498.09 891.09 414.1 891.09 426.1"/><rect x="604.07" y="498.09" width="15" height="230"/><rect x="331.55" y="429.97" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="499.04" y1="470.72" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="442.65" y1="457" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="386.23" y1="443.28" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="555.41" y1="484.43" x2="827.82" y2="404.16"/></svg>`,
      '4000': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="309.52 439.15 595.17 360.45 882.66 414.55 581.51 505.32 309.52 439.15"/><path fill="#f6f6f6" d="m595.26,362.5l278.98,52.5-292.79,88.25-263.97-64.22,277.77-76.52m-.17-4.1l-293.54,80.87,280.02,68.12,309.52-93.29-296-55.7h0Z"/></g><polygon points="581.57 519.39 301.55 451.27 301.55 439.27 581.57 507.39 581.57 519.39"/><polygon points="891.09 426.1 581.57 519.39 581.57 507.39 891.09 414.1 891.09 426.1"/><rect x="574.07" y="507.39" width="15" height="230"/><rect x="301.55" y="439.27" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="467.83" y1="479.72" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="411.05" y1="465.9" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="354.22" y1="452.08" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="524.57" y1="493.52" x2="827.82" y2="404.16"/></svg>`,
      '4500': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="279.49 448.04 595.17 360.45 882.66 414.54 551.51 514.22 279.49 448.04"/><path fill="#f6f6f6" d="m595.26,362.5l278.97,52.49-322.77,97.15-264.03-64.23,307.83-85.41m-.17-4.1l-323.54,89.77,280.02,68.12,339.52-102.2-296-55.7h0Z"/></g><polygon points="551.57 528.29 271.55 460.17 271.55 448.17 551.57 516.29 551.57 528.29"/><polygon points="891.09 426.1 551.57 528.29 551.57 516.29 891.09 414.1 891.09 426.1"/><rect x="544.07" y="516.29" width="15" height="230"/><rect x="271.55" y="448.17" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="437.35" y1="488.51" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="380.19" y1="474.6" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="322.97" y1="460.68" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="494.46" y1="502.4" x2="827.82" y2="404.16"/></svg>`
    },
    width: {
      '3124': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="393.16 426.13 620.17 365.25 857.34 409.9 620.03 481.32 393.16 426.13"/><path fill="#f6f6f6" d="m620.24,367.29l228.67,43.06-228.94,68.9-218.74-53.22,219.01-58.74m-.16-4.1l-235,63.03,235,57.17,245.68-73.94-245.68-46.26h0Z"/></g><polygon points="620.09 495.4 385.09 438.23 385.09 426.23 620.09 483.4 620.09 495.4"/><polygon points="866.09 421.47 620.09 495.4 620.09 483.4 866.09 409.47 866.09 421.47"/><rect x="612.59" y="483.4" width="15" height="230"/><rect x="385.09" y="426.23" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="561.34" y1="469.1" x2="800.18" y2="399.22"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="502.59" y1="454.81" x2="738.83" y2="387.57"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="443.84" y1="440.42" x2="676.56" y2="375.8"/></svg>`,
      '4088': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="370.67 420.66 595.17 360.45 882.66 414.54 642.56 486.81 370.67 420.66"/><path fill="#f6f6f6" d="m595.24,362.5l278.98,52.49-231.72,69.74-263.76-64.17,216.5-58.07m-.16-4.1l-232.49,62.36,280.02,68.12,248.47-74.78-296-55.7h0Z"/></g><polygon points="642.62 500.88 362.6 432.76 362.6 420.76 642.62 488.88 642.62 500.88"/><polygon points="891.09 426.1 642.62 500.88 642.62 488.88 891.09 414.1 891.09 426.1"/><rect x="635.12" y="488.88" width="15" height="230"/><rect x="362.6" y="420.76" width="15" height="205"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="530.59" y1="461.62" x2="768.04" y2="393.16"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="474.59" y1="448" x2="709.46" y2="381.81"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="418.59" y1="434.38" x2="650.38" y2="370.61"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="586.59" y1="475.25" x2="827.82" y2="404.16"/></svg>`,
      '5052': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="348.11 415.17 570.17 355.61 907.66 419.17 664.89 492.24 348.11 415.17"/><path fill="#f6f6f6" d="m570.24,357.66l328.99,61.96-234.39,70.55-308.65-75.09,214.06-57.41m-.16-4.1l-230.05,61.7,324.91,79.04,251.14-75.59-346-65.16h0Z"/></g><polygon points="664.95 506.31 340.04 427.27 340.04 415.27 664.95 494.31 664.95 506.31"/><polygon points="916.09 430.73 664.95 506.31 664.95 494.31 916.09 418.73 916.09 430.73"/><rect x="657.45" y="494.31" width="15" height="230"/><rect x="494.99" y="456.61" width="15" height="211.39"/><rect x="340.04" y="415.27" width="15" height="200.17"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="502.49" y1="454.79" x2="738.42" y2="387.38"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="448.41" y1="441.63" x2="681.03" y2="376.45"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="394.25" y1="428.45" x2="623.34" y2="365.6"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="556.73" y1="467.98" x2="796.65" y2="398.07"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="610.89" y1="481.16" x2="853.91" y2="409.04"/></svg>`,
      '6016': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="325.97 409.78 545.17 350.99 932.66 423.93 687.47 497.73 325.97 409.78"/><path fill="#f6f6f6" d="m545.24,353.04l378.99,71.34-236.82,71.28-353.37-85.97,211.2-56.65m-.16-4.1l-227.19,60.94,369.63,89.92,253.56-76.32-396-74.54h0Z"/></g><polygon points="687.52 511.8 317.9 421.88 317.9 409.88 687.52 499.8 687.52 511.8"/><polygon points="941.09 435.49 687.52 511.8 687.52 499.8 941.09 423.49 941.09 435.49"/><rect x="680.02" y="499.8" width="15" height="230"/><rect x="495.21" y="453.31" width="15" height="212.9"/><rect x="317.9" y="409.88" width="15" height="197.73"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="476.22" y1="448.4" x2="710.05" y2="382.23"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="423.51" y1="435.57" x2="653.64" y2="371.52"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="370.8" y1="422.75" x2="596.81" y2="360.92"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="528.93" y1="460.84" x2="766.89" y2="392.82"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="581.64" y1="474.04" x2="823.58" y2="403.46"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="634.35" y1="486.87" x2="880.09" y2="414.14"/></svg>`,
      '6980': `<svg viewBox="${zoomStandard}"><g><polyline fill="#b1b2b3" points="115.43 635.71 535.82 800.26 964.57 671.86 504.86 532.16 115.43 635.71"/></g><g><polygon fill="#c5c6c6" points="964.57 671.59 504.86 532.16 504.86 279.74 964.57 364.35 964.57 671.59"/></g><g><polygon fill="#f6f6f6" points="325.97 409.78 545.17 350.99 932.66 423.93 687.47 497.73 325.97 409.78"/><path fill="#f6f6f6" d="m545.24,353.04l378.99,71.34-236.82,71.28-353.37-85.97,211.2-56.65m-.16-4.1l-227.19,60.94,369.63,89.92,253.56-76.32-396-74.54h0Z"/></g><polygon points="687.52 511.8 317.9 421.88 317.9 409.88 687.52 499.8 687.52 511.8"/><polygon points="941.09 435.49 687.52 511.8 687.52 499.8 941.09 423.49 941.09 435.49"/><rect x="680.02" y="499.8" width="15" height="230"/><rect x="495.21" y="453.31" width="15" height="212.9"/><rect x="317.9" y="409.88" width="15" height="197.73"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="476.22" y1="448.4" x2="710.05" y2="382.23"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="423.51" y1="435.57" x2="653.64" y2="371.52"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="370.8" y1="422.75" x2="596.81" y2="360.92"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="528.93" y1="460.84" x2="766.89" y2="392.82"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="581.64" y1="474.04" x2="823.58" y2="403.46"/><line fill="none" stroke="#000" stroke-width="4" stroke-miterlimit="10" x1="634.35" y1="486.87" x2="880.09" y2="414.14"/></svg>`
    },
    addons: {
      'rund': `<svg viewBox="${zoomStandard}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m340,260h285.82c5.15,4.26,114.18,98.11,114.18,280,0,8.37-2.28,187.49-114.18,280h-285.82"/></svg>`,
      'klassisch': `<svg viewBox="${zoomStandard}"><polyline fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" points="342.37 257.63 742.37 257.63 742.37 349.96 652.37 495.52 652.37 578.87 561.61 723.26 561.61 817.63 342.37 817.63"/></svg>`,
      'beton': `<svg viewBox="${zoomBox}"><rect x="15" y="25" width="70" height="40" fill="#e0e0e0" stroke="#888" stroke-width="3"/><path d="M15 25 L 30 10 L 100 10 L 85 25" fill="#f0f0f0" stroke="#888" stroke-width="3"/><path d="M85 25 L 85 65 L 100 50 L 100 10" fill="#ccc" stroke="#888" stroke-width="3"/></svg>`,
      'beton_abfluss': `<svg viewBox="${zoomBox}"><rect x="15" y="25" width="70" height="40" fill="#e0e0e0" stroke="#888" stroke-width="3"/><path d="M15 25 L 30 10 L 100 10 L 85 25" fill="#f0f0f0" stroke="#888" stroke-width="3"/><circle cx="50" cy="45" r="10" fill="#333" stroke="#888" stroke-width="2"/></svg>`,
      'bohrer': `<svg viewBox="${zoomBox}"><rect x="20" y="30" width="60" height="15" fill="#aaa" stroke="#666" stroke-width="2"/><path d="M80 30 L 95 37.5 L 80 45" fill="#666"/><rect x="5" y="25" width="15" height="25" fill="#444"/></svg>`,
      'heizung': `<svg viewBox="${zoomBox}"><rect x="10" y="20" width="80" height="20" rx="5" fill="#333"/><path d="M15 50 Q 25 40, 35 50 T 55 50 T 75 50 T 95 50" stroke="orange" stroke-width="3" fill="none"/><path d="M15 60 Q 25 50, 35 60 T 55 60 T 75 60 T 95 60" stroke="orange" stroke-width="3" fill="none"/></svg>`,
      'montage': `<svg viewBox="${zoomBox}"><rect x="20" y="20" width="60" height="40" fill="#d2b48c" stroke="#8b4513" stroke-width="2"/><path d="M20 20 L 50 40 L 80 20" stroke="#8b4513" stroke-width="2"/><path d="M50 20 L 50 60" stroke="#8b4513" stroke-width="2"/></svg>`,
      'stift': `<svg viewBox="${zoomBox}"><rect x="30" y="20" width="40" height="40" fill="#333" stroke="#000"/><path d="M30 60 L 50 75 L 70 60" fill="#555"/><rect x="30" y="5" width="40" height="15" fill="#888"/></svg>`,
      'profil': `<svg viewBox="${zoomBox}"><rect x="30" y="10" width="20" height="60" fill="#ccc" stroke="#666" stroke-width="2"/><rect x="50" y="50" width="30" height="20" fill="#ccc" stroke="#666" stroke-width="2"/></svg>`,
      'led': `<svg viewBox="${zoomDetail}"><rect fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x="350" y="718.89" width="357.83" height="101.11" rx=".9" ry=".9"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m529.17,376.5h10.69c59.87,0,108.47,48.6,108.47,108.47v234.59h-227.63v-234.59c0-59.87,48.6-108.47,108.47-108.47Z"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m540,425.03c-5.09-.01-31.13.44-52.39,21.49-20.74,20.53-22.1,45.97-22.27,51.29"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m532.41,583.47h4.22c23.63,0,42.82,19.19,42.82,42.82v92.6h-89.86v-92.6c0-23.63,19.19-42.82,42.82-42.82Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="540" y1="260" x2="540" y2="339.13"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="740" y1="331.9" x2="679.93" y2="382.77"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="340" y1="331.9" x2="400.07" y2="382.77"/></svg>`,
      'keilfenster': `<svg viewBox="${zoomVertical}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m830,473.86H250v-212.55c0-.8.55-1.41,1.16-1.29l578,118.86c.49.1.84.65.84,1.29v93.69Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="473.86" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="473.86" x2="250" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="336.94" y1="321.65" x2="281.89" y2="355.61"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="375.67" y1="335.45" x2="320.62" y2="369.4"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="723.12" y1="397.27" x2="668.07" y2="431.22"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="761.85" y1="411.06" x2="706.8" y2="445.02"/><path d="m830,473.86H250v-212.55c0-.8.55-1.41,1.16-1.29l578,118.86c.49.1.84.65.84,1.29v93.69Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="473.86" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="473.86" x2="250" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="336.94" y1="321.65" x2="281.89" y2="355.61"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="375.67" y1="335.45" x2="320.62" y2="369.4"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="723.12" y1="397.27" x2="668.07" y2="431.22"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="761.85" y1="411.06" x2="706.8" y2="445.02"/></svg>`,
      'seitenwand': `<svg viewBox="${zoomVertical}"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m830,435.4H250v-174.33c0-.66.55-1.16,1.16-1.06l578,97.49c.49.08.84.53.84,1.06v76.84Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="830" y1="435.4" x2="830" y2="820"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x1="250" y1="435.4" x2="250" y2="820"/><path d="m670.43,447.81v347.19h-407.92v-347.19h407.92m25-25H237.51v397.19h457.92v-397.19h0Z"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="355.5" y1="487.97" x2="300.45" y2="521.92"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="394.23" y1="501.76" x2="339.18" y2="535.71"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="355.5" y1="487.97" x2="300.45" y2="521.92"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="588.32" y1="709.01" x2="533.27" y2="742.97"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="627.06" y1="722.81" x2="572" y2="756.76"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="588.32" y1="709.01" x2="533.27" y2="742.97"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="627.06" y1="722.81" x2="572" y2="756.76"/></svg>`,
      'schlagduebel': `<svg viewBox="400 200 280 680"><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m462.5,260h220v6.9c0,26.92-21.85,48.77-48.77,48.77h-122.46c-26.92,0-48.77-21.85-48.77-48.77v-6.9h0Z"/><rect fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" x="540" y="317.31" width="65" height="222.69"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="360.7" x2="605" y2="404.39"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="406.81" x2="605" y2="450.5"/><line fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="10px" x1="540" y1="452.92" x2="605" y2="496.61"/><path fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="25px" d="m587.32,820h-29.73c-2.86,0-5.26-2.01-5.55-4.66l-28.68-265.77c-.46-4.25,3.14-7.94,7.74-7.94h82.8c4.6,0,8.2,3.69,7.74,7.94l-28.78,265.77c-.29,2.64-2.68,4.65-5.55,4.65Z"/></svg>`
    },
    colors: {
      'RAL7016M': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#373F43"/></svg>`,
      'RAL9016': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#FFFFFF" stroke="#E5E7EB" stroke-width="3"/></svg>`,
      'RAL9005': `<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#1C1C1C"/></svg>`
    }
  };

  const fallbackSVG = `<svg viewBox="0 0 100 75"><rect width="100" height="75" fill="#f5f5f5"/><text x="50" y="50" font-size="20" text-anchor="middle" dominant-baseline="middle" fill="#ccc">?</text></svg>`;

  const varInput = document.getElementById('giallo-variant-id');
  const form = document.getElementById('giallo-product-form');
  if (!form) return;

  const getAllButtons = () => {
    const btnsInside = Array.from(form.querySelectorAll('button[type="submit"]'));
    const btnsOutside = Array.from(document.querySelectorAll('button[type="submit"][form="giallo-product-form"]'));
    return [...btnsInside, ...btnsOutside];
  };

  const titW = document.getElementById('tit-width');
  const titD = document.getElementById('tit-depth');
  const titC = document.getElementById('tit-color');
  const titA = document.getElementById('tit-addons');
  const titM = document.getElementById('tit-mount');

  const colorInput = document.getElementById('prop-color');
  const mountInput = document.getElementById('prop-mount');

  const warnBeam = document.getElementById('warn-beam');
  const reinfChk = document.getElementById('prop-reinf');
  const accItems = [...document.querySelectorAll('.g-acc__item')];
  const subItems = document.querySelectorAll('.g-acc__sub');

  const sumPriceLine = document.getElementById('sum-price-line');
  const sumAddonsPrice = document.getElementById('sum-addons-price');
  const sumPriceFinal = document.getElementById('sum-price-final');

  const sumDimensionsWrap = document.getElementById('sum-dimensions-wrap');
  const sumWidth = document.getElementById('sum-width');
  const sumDepth = document.getElementById('sum-depth');
  const sumColorWrap = document.getElementById('sum-color-wrap');
  const sumColor = document.getElementById('sum-color');
  const sumMountWrap = document.getElementById('sum-mount-wrap');
  const sumMount = document.getElementById('sum-mount');
  const sumAddonsWrap = document.getElementById('sum-addons-wrap');
  const sumAddonsList = document.getElementById('sum-addons-list');
  const validationMessage = document.getElementById('giallo-validation-message');

  const footerSummaryText = document.getElementById('footer-summary-text');
  const footerPriceFinal = document.getElementById('footer-price-final');

  const addonPriceCache = {};

  const fetchProductPrice = async (handle) => {
    if (addonPriceCache[handle]) return addonPriceCache[handle];
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return 0;
      const product = await response.json();
      const price = product.variants?.[0]?.price || 0;
      addonPriceCache[handle] = price;
      return price;
    } catch (e) {
      return 0;
    }
  };

  const fmt = (c) => (
    typeof Shopify !== 'undefined' && Shopify.formatMoney
      ? Shopify.formatMoney(c)
      : (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
  );

  const updateUIAddonPrices = async () => {
    const targets = form.querySelectorAll('[data-handle]');
    for (const t of targets) {
      const handle = t.dataset.handle;
      const price = await fetchProductPrice(handle);
      const card = t.closest('.g-card');
      const priceEl = card ? card.querySelector('.g-card__price') : null;
      if (priceEl) priceEl.textContent = fmt(price);
    }
  };

  function generateChoiceCards(containerId, inputName, options, type) {
    const container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = options.map(opt => {
      const iconSvg = (svgIcons[type] && svgIcons[type][opt]) ? svgIcons[type][opt] : fallbackSVG;
      return `
        <label class="g-card">
          <input type="radio" name="${inputName}" value="${opt}" class="visually-hidden">
          <div class="g-card__thumb">${iconSvg}</div>
          <div class="g-card__label">${opt} mm</div>
        </label>
      `;
    }).join('');
  }

  const unique = arr => [...new Set(arr)];
  const widths = unique(variants.map(v => v.option1)).sort();
  const depths = unique(variants.map(v => v.option2)).sort((a, b) => parseInt(a) - parseInt(b));

  generateChoiceCards('width-options-grid', 'opt-width', widths, 'width');
  generateChoiceCards('depth-options-grid', 'opt-depth', depths, 'depth');

  function updateStaticIcon(selector, iconKey, type) {
    if (!selector) return;
    const el = form.querySelector(selector);
    if (!el) return;

    const card = el.classList.contains('g-card') ? el : el.closest('.g-card');
    const thumb = card?.querySelector('.g-card__thumb');
    if (thumb && svgIcons[type] && svgIcons[type][iconKey]) {
      thumb.innerHTML = svgIcons[type][iconKey];
    }
  }

  function setMount(value, label) {
    if (!mountInput || !titM) return;

    mountInput.value = value || '';
    titM.textContent = label || '–';

    document.querySelectorAll('#mount-options .g-card').forEach(card => {
      const active = card.dataset.mount === value;
      card.setAttribute('aria-pressed', active ? 'true' : 'false');
      card.setAttribute('aria-checked', active ? 'true' : 'false');
    });
  }

  function setColor(val, labelText) {
    const colorCards = form.querySelectorAll('#color-swatches .g-card');
    colorInput.value = val || '';

    colorCards.forEach(c => {
      const active = c.dataset.color === val;
      c.setAttribute('aria-pressed', String(active));
      c.setAttribute('aria-checked', String(active));
    });

    const newColorText = labelText || (val || '–');
    if (titC && titC.textContent !== newColorText) {
      titC.textContent = newColorText;
      flashElement(titC);
    }

    validateAndRender();
  }

  const iconCards = form.querySelectorAll('.g-card__thumb[data-icon]');
  iconCards.forEach(thumb => {
    const iconKey = thumb.dataset.icon;
    if (svgIcons.addons[iconKey]) thumb.innerHTML = svgIcons.addons[iconKey];
  });

  updateStaticIcon('input[value="rund"]', 'rund', 'addons');
  updateStaticIcon('input[value="klassisch"]', 'klassisch', 'addons');
  updateStaticIcon('button[data-color="RAL7016M"]', 'RAL7016M', 'colors');
  updateStaticIcon('button[data-color="RAL9016"]', 'RAL9016', 'colors');
  updateStaticIcon('button[data-color="RAL9005"]', 'RAL9005', 'colors');

  accItems.forEach((item) => {
    const summary = item.querySelector('.g-acc__summary');
    const content = item.querySelector('.g-acc__body');

    if (item.hasAttribute('open')) {
      content.style.maxHeight = 'none';
    } else {
      content.style.maxHeight = '0px';
    }

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (item.hasAttribute('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        setTimeout(() => { content.style.maxHeight = '0px'; }, 10);
        setTimeout(() => { item.removeAttribute('open'); }, 500);
      } else {
        item.setAttribute('open', '');
        content.style.maxHeight = content.scrollHeight + 'px';
        setTimeout(() => {
          if (item.hasAttribute('open')) content.style.maxHeight = 'none';
        }, 500);
      }
    });
  });

  subItems.forEach((item) => {
    const summary = item.querySelector('.g-acc__sub-summary');
    const content = item.querySelector('.g-acc__sub-body');

    if (!item.hasAttribute('open')) content.style.maxHeight = '0px';

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (item.hasAttribute('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        setTimeout(() => { content.style.maxHeight = '0px'; }, 10);
        setTimeout(() => { item.removeAttribute('open'); }, 300);
      } else {
        item.setAttribute('open', '');
        content.style.maxHeight = content.scrollHeight + 'px';
        setTimeout(() => {
          if (item.hasAttribute('open')) content.style.maxHeight = 'none';
        }, 300);
      }
    });
  });

  const closeCurrentStep = (el) => {
    const currentItem = el.closest('.g-acc__item');
    if (currentItem && currentItem.hasAttribute('open')) {
      currentItem.querySelector('.g-acc__summary').click();
    }
  };

  const flashElement = (el) => {
    if (!el) return;
    el.classList.add('flash-animation');
    setTimeout(() => { el.classList.remove('flash-animation'); }, 700);
  };

  const getSelectedValue = name => form.querySelector(`input[name="${name}"]:checked`)?.value || '';

async function validateAndRender() {
  const w = getSelectedValue('opt-width');
  const d = getSelectedValue('opt-depth');
  const mount = mountInput ? mountInput.value : '';

  const variant = (w && d)
    ? variants.find(v => String(v.option1) === String(w) && String(v.option2) === String(d))
    : null;

  const newWidthText = w ? `${w} mm` : '–';
  if (titW && titW.textContent !== newWidthText) {
    titW.textContent = newWidthText;
    flashElement(titW);
  }

  const newDepthText = d ? `${d} mm` : '–';
  if (titD && titD.textContent !== newDepthText) {
    titD.textContent = newDepthText;
    flashElement(titD);
  }

  const newMountText = mount || '–';
  if (titM && titM.textContent !== newMountText) {
    titM.textContent = newMountText;
    flashElement(titM);
  }

  if (sumDimensionsWrap) sumDimensionsWrap.classList.toggle('hidden', !w || !d);
  if (sumWidth) sumWidth.textContent = w || '';
  if (sumDepth) sumDepth.textContent = d || '';

  if (sumColorWrap) sumColorWrap.classList.toggle('hidden', !colorInput.value);
  if (sumColor) sumColor.textContent = colorInput.value || '';

  if (sumMountWrap && sumMount) {
    sumMountWrap.classList.toggle('hidden', !mount);
    sumMount.textContent = mount || '';
  }

  const zier = getSelectedValue('addon-zierleiste');
  const qtyInputs = form.querySelectorAll('.addon-qty');
  let addonTextList = [];
  let hasQtyAddons = false;

  if (zier) addonTextList.push(zier);

  qtyInputs.forEach(input => {
    const qty = parseInt(input.value, 10) || 0;
    if (qty > 0) {
      hasQtyAddons = true;
      const card = input.closest('.g-card');
      const label = card?.querySelector('.g-card__label')?.textContent
        ?.replace(/[\n\r]+|[\s]{2,}/g, ' ')
        ?.trim() || '';
      addonTextList.push(`${qty}x ${label}`);
    }
  });

  if (sumAddonsWrap) sumAddonsWrap.classList.toggle('hidden', addonTextList.length === 0);
  if (sumAddonsList) sumAddonsList.textContent = addonTextList.join(', ');

  const is6000 = d === '6000';
  if (warnBeam) warnBeam.classList.toggle('hidden', !is6000);
  if (!is6000 && reinfChk) reinfChk.checked = false;

  let basePrice = 0;
  if (variant && variant.available) {
    varInput.value = variant.id;
    basePrice = Number(variant.price) || 0;
  } else {
    varInput.value = '';
  }

  let addonTotal = 0;

  if (zier) {
    const zierInput = form.querySelector('input[name="addon-zierleiste"]:checked');
    if (zierInput?.dataset.handle) {
      const price = await fetchProductPrice(zierInput.dataset.handle);
      addonTotal += price;
    }
  }

  for (const input of qtyInputs) {
    const qty = parseInt(input.value, 10) || 0;
    if (qty > 0) {
      const card = input.closest('.g-card');
      if (card?.dataset.handle) {
        const price = await fetchProductPrice(card.dataset.handle);
        addonTotal += price * qty;
      }
    }
  }

  const finalPrice = basePrice + addonTotal;

  if (sumPriceLine) sumPriceLine.textContent = fmt(basePrice);
  if (sumAddonsPrice) sumAddonsPrice.textContent = fmt(addonTotal);
  if (sumPriceFinal) sumPriceFinal.textContent = fmt(finalPrice);
  if (footerPriceFinal) footerPriceFinal.textContent = fmt(finalPrice);

  const summaryItems = [
    w && d ? `${w}x${d}mm` : null,
    colorInput.value || null,
    mount || null,
    zier || null,
    hasQtyAddons ? 'Zubehör' : null
  ].filter(Boolean);

  if (footerSummaryText) footerSummaryText.textContent = summaryItems.join(' / ');

  let totalAddonCount = 0;
  qtyInputs.forEach(i => {
    totalAddonCount += parseInt(i.value, 10) || 0;
  });
  if (zier) totalAddonCount += 1;

  const newAddonText = totalAddonCount > 0 ? `${totalAddonCount} Artikel` : '–';
  if (titA && titA.textContent !== newAddonText) {
    titA.textContent = newAddonText;
    flashElement(titA);
  }

  const missingSelections = [];
  if (!w) missingSelections.push('Breite');
  if (!d) missingSelections.push('Ausfall');
  if (!colorInput.value) missingSelections.push('Farbe');
  if (!mountInput.value) missingSelections.push('Montageart');
  if (d === '6000' && !reinfChk.checked) missingSelections.push('Bestätigung (6000mm)');

  const allButtons = getAllButtons();
  if (missingSelections.length > 0) {
    if (validationMessage) {
      validationMessage.textContent = `Bitte wählen Sie noch: ${missingSelections.join(', ')}`;
      validationMessage.classList.remove('hidden');
    }
    allButtons.forEach(btn => btn.disabled = true);
  } else {
    if (validationMessage) validationMessage.classList.add('hidden');
    const shouldDisable = !varInput.value;
    allButtons.forEach(btn => btn.disabled = shouldDisable);
  }
}

  const resetConfigurator = () => {
    form.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => input.checked = false);
    form.querySelectorAll('.addon-qty').forEach(i => i.value = 0);
    form.querySelectorAll('.g-card').forEach(c => c.classList.remove('has-qty'));

    subItems.forEach(item => {
      if (item.hasAttribute('open')) {
        item.removeAttribute('open');
        item.querySelector('.g-acc__sub-body').style.maxHeight = '0px';
      }
    });

    setColor('', '');
    setMount('', '');
    validateAndRender();

    accItems.forEach(item => {
      if (!item.hasAttribute('open')) item.querySelector('.g-acc__summary').click();
    });

    document.querySelector('.g-acc__item[data-step="1"]')?.scrollIntoView({ behavior: 'smooth' });
  };

  form.querySelector('#color-swatches')?.addEventListener('click', (e) => {
    const card = e.target.closest('.g-card');
    if (card) {
      setColor(card.dataset.color, card.dataset.label);
      closeCurrentStep(card);
    }
  });

  form.addEventListener('change', (e) => {
    const target = e.target;
    if (target.matches('input[type="radio"]')) {
      const is6000mmRadio = target.name === 'opt-depth' && target.value === '6000';
      const inAddons = target.closest('#giallo-addons');

      if (!inAddons && !is6000mmRadio) {
        closeCurrentStep(target);
      }
    }
    validateAndRender();
  });

  form.addEventListener('click', (e) => {
    if (e.target.matches('.g-qty-btn')) {
      const btn = e.target;
      const wrapper = btn.closest('.g-qty-wrapper');
      const input = wrapper.querySelector('input');
      const card = btn.closest('.g-card');
      let val = parseInt(input.value) || 0;

      if (btn.classList.contains('plus')) {
        val++;
      } else if (btn.classList.contains('minus')) {
        if (val > 0) val--;
      }

      input.value = val;

      if (val > 0) {
        card.classList.add('has-qty');
      } else {
        card.classList.remove('has-qty');
      }

      validateAndRender();
    }
  });

document.querySelectorAll('#mount-options .g-card').forEach(card => {
  card.addEventListener('click', () => {
    setMount(card.dataset.mount, card.dataset.label);
    closeCurrentStep(card);
    validateAndRender();
  });
});

  document.getElementById('addon-zierleiste-clear')?.addEventListener('click', () => {
    const r = form.querySelector('input[name="addon-zierleiste"]:checked');
    if (r) r.checked = false;
    validateAndRender();
  });

  document.getElementById('giallo-reset-btn')?.addEventListener('click', resetConfigurator);

  const handleAddClick = (e) => {
    const btn = e.currentTarget;
    if (btn && btn.disabled) {
      e.preventDefault();
      if (validationMessage && !validationMessage.classList.contains('hidden')) {
        validationMessage.classList.add('shake-animation');
        setTimeout(() => { validationMessage.classList.remove('shake-animation'); }, 600);
      }
    }
  };

  getAllButtons().forEach(btn => {
    btn.addEventListener('click', handleAddClick);
  });

  updateUIAddonPrices();
  validateAndRender();

  async function getFirstVariantIdByHandle(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      const p = await res.json();
      return p?.variants?.[0]?.id || null;
    } catch (e) {
      return null;
    }
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const allButtons = getAllButtons();
    if (allButtons.some(btn => btn.disabled)) return;

    allButtons.forEach(btn => btn.disabled = true);

    try {
      const mainVariantId = varInput.value;
      if (!mainVariantId) return;

      const configurationId = Date.now();
      const formData = new FormData(form);
      const properties = {};

      for (const [k, v] of formData.entries()) {
        if (k.startsWith('properties[')) properties[k.slice(11, -1)] = v;
      }
      properties['_config_id'] = configurationId;

      const addItems = [{ id: Number(mainVariantId), quantity: 1, properties }];

      const zier = form.querySelector('input[name="addon-zierleiste"]:checked');
      if (zier) {
        const vid = await getFirstVariantIdByHandle(zier.dataset.handle);
        if (vid) {
          addItems.push({
            id: Number(vid),
            quantity: 1,
            properties: {
              _parent: String(mainVariantId),
              _lock_qty: '1',
              _config_id: configurationId
            }
          });
        }
      }

      const qtyInputs = form.querySelectorAll('.addon-qty');
      for (const input of qtyInputs) {
        const qty = parseInt(input.value);
        if (qty > 0) {
          const card = input.closest('.g-card');
          const vid = await getFirstVariantIdByHandle(card.dataset.handle);
          if (vid) {
            addItems.push({
              id: Number(vid),
              quantity: qty,
              properties: {
                _parent: String(mainVariantId),
                _config_id: configurationId
              }
            });
          }
        }
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: addItems })
      });

      if (res.ok) {
        window.location.href = '/cart';
      } else {
        const err = await res.json().catch(() => ({}));
        alert(err?.message || 'Fehler: Artikel konnte nicht in den Warenkorb gelegt werden.');
      }
    } catch (err) {
      alert('Ein Netzwerkfehler ist aufgetreten.');
    } finally {
      allButtons.forEach(btn => btn.disabled = false);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
